import type { Messages } from './types.ts';

export const ar: Messages = {
  shell: {
    help: 'المساعدة والدعم',
    helpWhatsapp: 'واتساب',
    helpWhatsappHint: 'راسل فريقنا',
    helpGuides: 'أدلة بالفيديو',
    helpGuidesHint: 'دليل لكل شاشة',
    helpCenter: 'مركز المساعدة',
    helpCenterHint: 'مقالات وأسئلة شائعة',
    searching: 'جارٍ البحث…',
    orderResult: '{{number}} · {{customer}}',
    ordersFound: 'الطلبات',
    appName: 'Al-WidadiaShop',
    search: 'ابحث عن طلب أو منتج…',
    searchPlaceholder: 'طلب، منتج، عميل، صفحة…',
    commands: 'أوامر سريعة',
    noResults: 'لا توجد نتائج',
    userMenu: 'قائمة المستخدم',
    tenant: 'المتجر',
    badge_ordersToConfirm_zero: '{{label}}، لا طلبات للتأكيد',
    badge_ordersToConfirm_one: '{{label}}، طلب واحد للتأكيد',
    badge_ordersToConfirm_two: '{{label}}، طلبان للتأكيد',
    badge_ordersToConfirm_few: '{{label}}، {{count}} طلبات للتأكيد',
    badge_ordersToConfirm_many: '{{label}}، {{count}} طلبًا للتأكيد',
    badge_ordersToConfirm_other: '{{label}}، {{count}} طلب للتأكيد',
    badge_missingParcels_zero: '{{label}}، لا طرود مفقودة',
    badge_missingParcels_one: '{{label}}، طرد مفقود واحد',
    badge_missingParcels_two: '{{label}}، طردان مفقودان',
    badge_missingParcels_few: '{{label}}، {{count}} طرود مفقودة',
    badge_missingParcels_many: '{{label}}، {{count}} طردًا مفقودًا',
    badge_missingParcels_other: '{{label}}، {{count}} طرد مفقود',
    switchTenant: 'تغيير المتجر',
    switchTenantConfirm: 'تغيير',
    logout: 'تسجيل الخروج',
    login: 'تسجيل الدخول',
    loggingIn: 'جارٍ التحويل إلى صفحة الدخول…',
    checkingSession: 'جارٍ التحقق من جلستك…',
    openingWorkspace: 'جارٍ تجهيز مساحة عملك…',
    stepSession: 'الجلسة',
    stepSignIn: 'الدخول',
    stepWorkspace: 'مساحة العمل',
    secureSignIn: 'دخول موحّد وآمن',
    menu: 'القائمة',
    collapse: 'طيّ القائمة',
    expand: 'توسيع القائمة',
    loading: 'جارٍ التحميل',
    loginFailedTitle: 'تعذر تسجيل الدخول',
    callbackFailed: 'تعذر إكمال الجلسة. عد إلى الصفحة الرئيسية وسجّل الدخول من جديد.',
    loginFailed: 'فشل تسجيل الدخول. تأكد من تشغيل Keycloak ثم أعد المحاولة.',
    signInTitle: 'مرحبًا بعودتك',
    signInDescription: 'سجّل الدخول بحساب Al-WidadiaShop لفتح مساحة عملك.',
    sessionExpiredTitle: 'انتهت صلاحية جلستك',
    sessionExpiredDescription:
      'حفاظًا على أمانك، تم تسجيل خروجك بعد فترة من عدم النشاط. سجّل الدخول مجددًا لمتابعة عملك من حيث توقفت.',
    insecureContext: 'يتطلب تسجيل الدخول سياقًا آمنًا. افتح التطبيق عبر HTTPS أو من أصل حلقي.',
    forbidden: 'ليس لديك صلاحية الوصول إلى هذه الصفحة.',
    backHome: 'العودة إلى لوحة التحكم',
    language: 'اللغة',
    theme: 'المظهر',
    theme_light: 'فاتح',
    theme_dark: 'داكن',
    toggleTheme: 'التبديل إلى السمة: {{theme}}',
    theme_system: 'النظام',
    density: 'الكثافة',
    density_comfortable: 'مريحة',
    density_compact: 'مضغوطة',
    density_spacious: 'واسعة',
    densityHint_compact: 'معلومات أكثر على الشاشة',
    densityHint_comfortable: 'متوازنة',
    densityHint_spacious: 'مساحة أكبر وقراءة أسهل',
  },
  nav: {
    statistics: 'الإحصائيات',
    statistics_delivery: 'التوصيل',
    statistics_confirmation: 'التأكيد',
    statistics_products: 'المنتجات',
    statistics_orders: 'الطلبات',
    statistics_marketing: 'التسويق',
    calculator: 'الحاسبة',
    labels: 'الملصقات',
    financeOverview: 'نظرة عامة',
    remittances: 'كشوفات شركات التوصيل',
    disputes: 'النزاعات',
    expenses: 'المصاريف',
    handoverShort: 'التسليم',
    group_sales: 'المبيعات',
    group_logistics: 'اللوجستيك',
    group_catalog: 'الكتالوج',
    handover: 'التسليم لشركة التوصيل',
    returns: 'المرتجعات',
    returnedParcels: 'المُرجَعة',
    missingParcels: 'المفقودة',
    finance: 'المالية',
    dashboard: 'لوحة التحكم',
    orders: 'الطلبات',
    products: 'المنتجات',
    settings: 'الإعدادات',
    categories: 'الفئات',
    inventory: 'المخزون',
    tenants: 'المتاجر',
    customers: 'الحرفاء',
    history: 'سجل التعديلات',
    newOrder: 'طلب جديد',
  },
  dashboard: {
    filters: {
      product: 'المنتج',
      allProducts: 'كل المنتجات',
      findProduct: 'ابحث عن منتج (الاسم أو المرجع)',
      noProductMatch: 'لا يوجد منتج',
      origin: 'المصدر',
      allOrigins: 'كل المصادر',
      allImported: 'مستورد (كل البلدان)',
      shopWideHidden: 'المصاريف وصافي الربح تخص المتجر كله، لذلك تُخفى عند اختيار منتج أو مصدر.',
    },
    greeting: 'مرحبًا {{name}}',
    openOrders: 'عرض الطلبات',
    newOrder: 'طلب جديد',
    newProduct: 'إضافة منتج',
    points: '{{value}} نقطة',
    deltaLabel: '{{value}} مقارنة بالمدة نفسها قبلها مباشرة',
    noOrdersTitle: 'لا توجد طلبات في هذه الفترة',
    noOrdersDescription: 'ستظهر المبيعات والتوصيلات والمرتجعات هنا منذ أول طلب.',
    seeInventory: 'فتح المخزون',
    urgentNoneHelp: 'لا يوجد منتج تحت حد المخزون المنخفض.',
    urgentNone: 'لا شيء للتزويد',
    urgentOut: 'نفد',
    urgentThreshold: 'الحد {{count}}',
    urgentLeft: 'المتبقي {{count}}',
    urgentTitle: 'للتزويد',
    noDepotsHelp: 'أنشئ مستودعًا في قسم المخزون لمتابعة الكميات.',
    noDepots: 'لا يوجد مستودع نشط',
    valueMissing: 'منتجات متوفرة بلا تكلفة: {{count}}. القيمة أقل من الحقيقة.',
    value: 'القيمة',
    out: 'نفد',
    low: 'مخزون منخفض',
    reserved: 'محجوز',
    available: 'متوفر',
    inStock: 'منتجات متوفرة',
    depot: 'المستودع',
    depotsTitle: 'المخزون حسب المستودع',
    stockValue: 'قيمة المخزون (بالتكلفة)',
    outOfStock: 'منتجات نفدت',
    toRestock: 'للتزويد',
    availableUnits: 'الوحدات المتوفرة',
    stockContext: 'ما هو متوفر الآن في كل مستودع، وما يجب إعادة شرائه.',
    title: 'لوحة التحكم',
    context: 'نشاط المتجر ونتيجته ومخزونه',
    activeProducts: 'منتجات نشطة',
    pendingMovements: 'حركات معلّقة',
    emptyTitle: 'لا توجد منتجات بعد',
    emptyDescription: 'أضف أول منتج لتظهر هذه المؤشرات.',
    performanceTitle: 'نشاط الفترة',
    created: 'الطلبات المنشأة',
    delivered: 'الطلبات المسلّمة',
    deliveryRate: 'نسبة التسليم',
    returned: 'المرتجعات',
    canceled: 'الملغاة',
    sales: 'المبيعات المسلّمة',
    grossMargin: 'الهامش الإجمالي',
    net: 'النتيجة الصافية',
    recentTitle: 'الطلبات المُنشأة',
    recentLabel_zero: 'الطلبات المُنشأة',
    recentLabel_one: 'الطلبات المُنشأة في اليوم الأخير',
    recentLabel_two: 'الطلبات المُنشأة يوميًا خلال اليومين الأخيرين',
    recentLabel_few: 'الطلبات المُنشأة يوميًا خلال آخر {{count}} أيام',
    recentLabel_many: 'الطلبات المُنشأة يوميًا خلال آخر {{count}} يومًا',
    recentLabel_other: 'الطلبات المُنشأة يوميًا خلال آخر {{count}} يوم',
    recentDays_zero: '{{count}} يوم',
    recentDays_one: 'يوم',
    recentDays_two: 'يومان',
    recentDays_few: '{{count}} أيام',
    recentDays_many: '{{count}} يومًا',
    recentDays_other: '{{count}} يوم',
    parcelsTitle: 'طرود قيد الشحن',
    parcelsTotal_zero: 'لا طرود لدى شركات التوصيل',
    parcelsTotal_one: 'طرد واحد لدى شركات التوصيل',
    parcelsTotal_two: 'طردان لدى شركات التوصيل',
    parcelsTotal_few: '{{total}} طرود لدى شركات التوصيل',
    parcelsTotal_many: '{{total}} طردًا لدى شركات التوصيل',
    parcelsTotal_other: '{{total}} طرد لدى شركات التوصيل',
    parcelsNone: 'لا طرود لدى شركات التوصيل',
    parcelsNoneHelp: 'تظهر الطرود المشحونة هنا حتى تسليمها أو إرجاعها.',
    awaitingConfirmation_zero: 'لا طلبات بانتظار التأكيد',
    awaitingConfirmation_one: 'طلب واحد بانتظار التأكيد',
    awaitingConfirmation_two: 'طلبان بانتظار التأكيد',
    awaitingConfirmation_few: '{{total}} طلبات بانتظار التأكيد',
    awaitingConfirmation_many: '{{total}} طلبًا بانتظار التأكيد',
    awaitingConfirmation_other: '{{total}} طلب بانتظار التأكيد',
    seriesTitle: 'التطور',
    chartLabel: '{{metric}} حسب الفترة',
    resultTitle: 'حساب النتيجة',
    costOfGoods: 'تكلفة المنتجات المباعة',
    carrierFees: 'مصاريف شركات التوصيل',
    returnFees: 'مصاريف الإرجاع',
    damageLoss: 'خسائر المنتجات التالفة',
    expenses: 'المصاريف',
    returnedValue: 'قيمة المرتجعات',
    missingCosts: 'أسطر مباعة بلا تكلفة: {{count}}. الهامش مبالغ فيه ما دامت تكلفة المنتجات غير مدخلة.',
    costHidden: 'الهامش والنتيجة الصافية متاحان فقط لمن يطّلع على التكاليف.',
    topTitle: 'الأكثر مبيعًا',
    product: 'المنتج',
    sku: 'المرجع',
    units: 'الوحدات',
    margin: 'الهامش',
    noSales: 'لا توجد مبيعات مسلّمة في هذه الفترة',
    noSalesHelp: 'تظهر المنتجات هنا بمجرد تسليم طلب.',
    stockTitle: 'الكتالوج والمخزون',
    overview: {
      stockUnitsAt_one: 'وحدة واحدة · {{price}} للوحدة',
      stockUnitsAt_other: '{{total}} وحدات · {{price}} للوحدة',
      stockPurchaseValue: 'المخزون بسعر الشراء',
      stockSaleValue: 'المخزون بسعر البيع',
      stockUnits_one: 'وحدة واحدة في المخزون',
      stockUnits_other: '{{total}} وحدات في المخزون',
      from: 'من',
      to: 'إلى',
      products: 'المنتجات',
      depots: 'المستودعات',
      charges: 'المصاريف',
      totalGains: 'إجمالي الأرباح',
      totalReturns: 'إجمالي المرتجعات',
      defectiveProducts: 'المنتجات المعيبة',
      netProfit: 'صافي الربح',
      totalSales: 'إجمالي المبيعات',
      deliveredSales: 'المبيعات المسلّمة',
      netSalesGain: 'صافي ربح المبيعات',
      pendingSales: 'المبيعات قيد الانتظار',
      salesCount_zero: 'لا مبيعات',
      salesCount_one: 'عملية بيع واحدة',
      salesCount_two: 'عمليتا بيع',
      salesCount_few: '{{total}} عمليات بيع',
      salesCount_many: '{{total}} عملية بيع',
      salesCount_other: '{{total}} عملية بيع',
      deliveredCount_zero: 'لا شيء مسلّم',
      deliveredCount_one: 'طلب واحد مسلّم',
      deliveredCount_two: 'طلبان مسلّمان',
      deliveredCount_few: '{{total}} طلبات مسلّمة',
      deliveredCount_many: '{{total}} طلبًا مسلّمًا',
      deliveredCount_other: '{{total}} طلب مسلّم',
      pendingCount_zero: 'لا شيء قيد الانتظار',
      pendingCount_one: 'طلب واحد قيد الانتظار',
      pendingCount_two: 'طلبان قيد الانتظار',
      pendingCount_few: '{{total}} طلبات قيد الانتظار',
      pendingCount_many: '{{total}} طلبًا قيد الانتظار',
      pendingCount_other: '{{total}} طلب قيد الانتظار',
      deliveredOrders_zero: 'لا طلبات مسلّمة',
      deliveredOrders_one: 'طلب واحد مسلّم',
      deliveredOrders_two: 'طلبان مسلّمان',
      deliveredOrders_few: '{{total}} طلبات مسلّمة',
      deliveredOrders_many: '{{total}} طلبًا مسلّمًا',
      deliveredOrders_other: '{{total}} طلب مسلّم',
      returnedOrders_zero: 'لا طلبات مرتجعة',
      returnedOrders_one: 'طلب واحد مرتجع',
      returnedOrders_two: 'طلبان مرتجعان',
      returnedOrders_few: '{{total}} طلبات مرتجعة',
      returnedOrders_many: '{{total}} طلبًا مرتجعًا',
      returnedOrders_other: '{{total}} طلب مرتجع',
      damagedUnits_zero: 'لا وحدات تالفة',
      damagedUnits_one: 'وحدة تالفة واحدة',
      damagedUnits_two: 'وحدتان تالفتان',
      damagedUnits_few: '{{total}} وحدات تالفة',
      damagedUnits_many: '{{total}} وحدة تالفة',
      damagedUnits_other: '{{total}} وحدة تالفة',
      soldUnits_zero: 'لا وحدات مباعة',
      soldUnits_one: 'وحدة مباعة واحدة',
      soldUnits_two: 'وحدتان مباعتان',
      soldUnits_few: '{{total}} وحدات مباعة',
      soldUnits_many: '{{total}} وحدة مباعة',
      soldUnits_other: '{{total}} وحدة مباعة',
      topProductsTitle: 'أفضل المنتجات',
      customize: 'تخصيص',
      groupLabel: 'التجميع',
      group: {
        auto: 'تلقائي',
        day: 'حسب اليوم',
        week: 'حسب الأسبوع',
        month: 'حسب الشهر',
      },
      rankLabel: 'الترتيب',
      rank: {
        units: 'حسب الوحدات',
        sales: 'حسب المبلغ',
      },
      rankTitle: {
        units: 'الوحدات المباعة حسب المنتج',
        sales: 'المبلغ المباع حسب المنتج',
      },
      sizeLabel: 'عدد المنتجات',
      size_zero: 'أفضل {{count}}',
      size_one: 'أفضل {{count}}',
      size_two: 'أفضل {{count}}',
      size_few: 'أفضل {{count}}',
      size_many: 'أفضل {{count}}',
      size_other: 'أفضل {{count}}',
      unitsSold_zero: 'لا وحدات',
      unitsSold_one: 'وحدة واحدة',
      unitsSold_two: 'وحدتان',
      unitsSold_few: '{{total}} وحدات',
      unitsSold_many: '{{total}} وحدة',
      unitsSold_other: '{{total}} وحدة',
    },
    widgets: {
      deltaLabel: '{{value}} مقارنة بالفترة المقارَنة',
      comparisonSeries: 'الفترة المقارَنة',
      trendTitle: {
        sales: 'تطور الأرباح',
        created: 'تطور المبيعات',
        confirmed: 'تطور الطلبات المؤكدة',
        delivered: 'تطور المبيعات المسلّمة',
        returned: 'تطور المرتجعات',
        canceled: 'تطور الطلبات الملغاة',
      },
      trendMeasure: {
        sales: 'الأرباح',
        created: 'المبيعات',
        confirmed: 'الطلبات المؤكدة',
        delivered: 'المبيعات المسلّمة',
        returned: 'المرتجعات',
        canceled: 'الطلبات الملغاة',
      },
      breakdownTitle: {
        orders: 'الطلبات حسب {{dimension}}',
        delivered: 'التسليمات حسب {{dimension}}',
        returned: 'المرتجعات حسب {{dimension}}',
        sales: 'الأرباح حسب {{dimension}}',
        deliveryRate: 'نسبة التسليم حسب {{dimension}}',
      },
      breakdownMeasure: {
        orders: 'الطلبات',
        delivered: 'المسلّمة',
        returned: 'المرتجعة',
        sales: 'الأرباح',
        deliveryRate: 'نسبة التسليم',
      },
      dimension: {
        carrier: 'شركة النقل',
        governorate: 'الولاية',
        source: 'المصدر',
        status: 'الحالة',
      },
      noCarrier: 'بدون شركة نقل بعد',
      noGovernorate: 'بدون ولاية',
      other: 'أخرى',
      versus: '{{value}} (مقابل {{previous}})',
      kind: {
        funnel: 'قمع الطلبات',
      },
      funnelStep: {
        received: 'المستلمة',
        confirmed: 'المؤكدة',
        shipped: 'المسلّمة لشركة النقل',
        delivered: 'المسلّمة للزبون',
      },
      funnelFirst: 'كل الطلبات المنشأة خلال الفترة',
      funnelShare: '{{ofFirst}} من الطلبات · {{fromPrevious}} من المرحلة السابقة',
      funnelReturned_one: 'عاد {{total}} طلب',
      funnelReturned_other: 'عادت {{total}} طلبات',
      field: {
        tile: 'المؤشر',
        measure: 'المقياس',
        chart: 'الرسم البياني',
        dimension: 'التوزيع حسب',
        title: 'العنوان',
        titleHelp: 'اتركه فارغًا للإبقاء على العنوان المقترح.',
        size: 'العرض',
      },
      chart: {
        line: 'منحنيات',
        area: 'مساحة',
        columns: 'أعمدة',
        stacked: 'أشرطة متراكبة',
        grouped: 'أشرطة متجاورة',
        barList: 'أشرطة مرتبة',
        donut: 'حلقة',
      },
      size: {
        sm: 'صغير (ربع)',
        md: 'متوسط (ثلث)',
        lg: 'كبير (ثلثان)',
        full: 'العرض الكامل',
      },
      settingsTitle: 'إعدادات العنصر',
      apply: 'تطبيق',
      preview: 'معاينة',
      galleryTitle: 'إضافة عنصر',
      gallerySubtitle: 'اختر مؤشرًا أو رسمًا بيانيًا؛ يمكنك تعديله لاحقًا.',
      galleryFull: 'يحتوي هذا العرض على 24 عنصرًا. احذف عنصرًا لإضافة آخر.',
      group: {
        indicators: 'المؤشرات الرئيسية',
        trends: 'التطورات',
        breakdowns: 'التوزيعات',
        orders: 'الطلبات والمنتجات',
      },
      preset: {
        kpi: {
          description: 'مؤشر مع اتجاهه والفرق مع الفترة المقارَنة.',
        },
        salesTrend: {
          title: 'تطور الأرباح',
          description: 'المبيعات المسلّمة كمساحة، مع الفترة المقارَنة بخط متقطع.',
        },
        ordersTrend: {
          title: 'تطور الطلبات',
          description: 'الطلبات المنشأة كمنحنى.',
        },
        returnsTrend: {
          title: 'المرتجعات أسبوعيًا',
          description: 'الطلبات المرتجعة أسبوعًا بأسبوع.',
        },
        deliveryRateByCarrier: {
          title: 'نسبة التسليم حسب شركة النقل',
          description: 'منحنى لكل شركة نقل، أسبوعًا بأسبوع.',
        },
        ordersByCarrier: {
          title: 'الطلبات حسب شركة النقل',
          description: 'أشرطة متجاورة لكل شركة نقل.',
        },
        statusesByDay: {
          title: 'حالات الطلبات يوميًا',
          description: 'أين وصلت طلبات كل يوم، بشكل متراكب.',
        },
        salesBySource: {
          title: 'الأرباح حسب المصدر',
          description: 'فيسبوك، إنستغرام، الهاتف… كحلقة.',
        },
        ordersByGovernorate: {
          title: 'الطلبات حسب الولاية',
          description: 'الولايات الأكثر طلبًا.',
        },
        funnel: {
          title: 'قمع الطلبات',
          description: 'من الاستلام إلى التسليم، مع الخسارة في كل مرحلة.',
        },
        topProducts: {
          title: 'أفضل المنتجات',
          description: 'المنتجات الأكثر مبيعًا كأشرطة مرتبة.',
        },
      },
      compareLabel: 'المقارنة مع',
      compare: {
        none: 'بدون مقارنة',
        previous: 'الفترة السابقة',
        last_year: 'نفس الفترة من السنة الماضية',
      },
      drag: 'اسحب {{title}} لنقله',
      moveEarlier: 'تقديم {{title}}',
      moveLater: 'تأخير {{title}}',
      configure: 'إعدادات {{title}}',
      remove: 'إزالة {{title}}',
      editing: 'تخصيص لوحة القيادة',
      editHint: 'اسحب العناصر أو استعمل الأسهم لإعادة ترتيبها، افتح إعداداتها، ثم احفظ.',
      add: 'إضافة عنصر',
    },
    views: {
      options: 'خيارات العرض',
      leaveTitle: 'المغادرة دون حفظ؟',
      leaveMessage: 'لم تُحفظ تعديلاتك على لوحة القيادة بعد.',
      leave: 'مغادرة',
      stay: 'البقاء والحفظ',
      label: 'عرض لوحة القيادة',
      standard: 'العرض القياسي',
      defaultName: '{{name}} (افتراضي)',
      makeDefault: 'فتح هذا العرض افتراضيًا',
      rename: 'إعادة تسمية العرض',
      delete: 'حذف العرض',
      saveAs: 'الحفظ كعرض جديد',
      saveAsTitle: 'الحفظ كعرض جديد',
      renameTitle: 'إعادة تسمية العرض',
      nameLabel: 'الاسم',
      nameRequired: 'أعطِ العرض اسمًا.',
      deleteTitle: 'حذف هذا العرض؟',
      deleteMessage: 'سيُحذف العرض «{{name}}». يبقى العرض القياسي متاحًا.',
      created: 'تم حفظ العرض',
      updated: 'تم تحديث العرض',
      deleted: 'تم حذف العرض',
      madeDefault: 'يُفتح هذا العرض الآن افتراضيًا',
      failed: 'تعذّر حفظ العرض. أعد المحاولة.',
    },
  },
  period: {
    legend: 'الفترة',
    today: 'اليوم',
    last_7_days: 'آخر 7 أيام',
    this_month: 'هذا الشهر',
    last_month: 'الشهر الماضي',
    this_year: 'هذه السنة',
  },
  placeholder: { comingSoon: 'هذه الشاشة ستتوفر في المرحلة القادمة.' },
  common: {
    rowAction: '{{action}}: {{name}}',
    copyBarcode: 'نسخ الرمز الشريطي {{code}}',
    barcodeCopied: 'تم نسخ الرمز الشريطي',
    copyFailed: 'تعذّر النسخ: حدّد الرمز الشريطي وانسخه يدويًا.',
    clearFilters: 'مسح عوامل التصفية',
    refineSearch: 'عرض {{shown}} من {{total}} نتيجة: دقّق البحث.',
    shown: '{{shown}} من {{total}}',
    loadMore: 'عرض المزيد',
    loadingMore: 'جارٍ التحميل…',
    retry: 'إعادة المحاولة',
    cancel: 'إلغاء',
    save: 'حفظ',
    saving: 'جارٍ الحفظ…',
    close: 'إغلاق',
    all: 'الكل',
  },
  catalog: {
    categoriesContext: 'نظّم منتجاتك في أقسام وأقسام فرعية.',
    productsContext: 'الكتالوج والمتغيّرات: الأسعار والمخزون حسب المستودع وحالة النشر.',
    name: 'الاسم',
    slug: 'العنوان',
    status: 'الحالة',
    status_all: 'الكل',
    status_active: 'نشط',
    status_archived: 'مؤرشف',
    status_draft: 'غير نشط',
    position: 'الترتيب',
    positionHelp: 'ترتيب العرض، من الأصغر إلى الأكبر.',
    parent: 'الفئة الأصل',
    noParent: 'بدون (قسم رئيسي)',
    actions: 'إجراءات',
    delete: 'حذف',
    newCategory: 'فئة جديدة',
    editCategory: 'تعديل الفئة',
    categorySaved: 'تم حفظ الفئة',
    categoryArchived: 'تمت أرشفة الفئة',
    noCategories: 'لا توجد فئات',
    noCategoriesHelp: 'أنشئ أول فئة لتنظيم منتجاتك.',
    nameRequired: 'الاسم إجباري',
    loadFailed: 'تعذّر التحميل',
    reference: 'المرجع',
    variants: 'المتغيّرات',
    price: 'السعر',
    search: 'بحث',
    searchPlaceholder: 'الاسم أو المرجع أو SKU',
    searchSubmit: 'تشغيل البحث',
    category: 'الفئة',
    newProduct: 'منتج جديد',
    productSaved: 'تم حفظ المنتج',
    productArchived: 'تمت أرشفة المنتج',
    noProducts: 'لا توجد منتجات',
    noProductsHelp: 'أنشئ أول منتج لتبدأ البيع.',
    sku: 'SKU',
  },
  origin: {
    local: 'محلي',
    imported: 'مستورد · {{country}}',
  },
  productEditor: {
    essentialsHint: 'الاسم والوصف والتصنيف الذي يراه حرفاؤك.',
    mediaHint: 'الصور الواضحة تبيع أكثر؛ الصورة الأولى هي الغلاف.',
    pricingHint: 'كلفة الشراء وسعر البيع والتخفيض.',
    variantsHint: 'المقاسات والألوان ورمز كل نسخة.',
    stockHint: 'الكميات حسب المخزن وحدّ التنبيه.',
    shippingHint: 'الوزن والأبعاد التي تُرسل إلى الناقل.',
    moreHint: 'الضمان ومعلومات إضافية.',
    media: 'الوسائط',
    mediaDrop: 'أفلت الصور هنا أو انقر لاختيارها',
    mediaHelp: 'JPEG أو PNG أو WebP أو AVIF، بحد أقصى 10 ميغابايت. يمكنك أيضًا لصق صورة.',
    mediaEmpty: 'لا توجد صور بعد. أول صورة تضيفها تصبح صورة الغلاف.',
    mediaGallery: 'صور المنتج',
    mediaImage: 'الصورة {{position}}',
    mediaCover: 'الغلاف',
    mediaAlt: 'وصف الصورة',
    mediaEarlier: 'تقديم الصورة {{position}}',
    mediaLater: 'تأخير الصورة {{position}}',
    mediaRemove: 'إزالة الصورة {{position}}',
    mediaDismiss: 'تجاهل',
    mediaAdd: 'إضافة',
    mediaRefused: '{{name}} ليس صورة مقبولة (JPEG أو PNG أو WebP أو AVIF).',
    mediaPhase_hashing: 'جارٍ التحضير…',
    mediaPhase_uploading: 'جارٍ الإرسال…',
    mediaPhase_processing: 'جارٍ الفحص والتحسين…',
    newTitle: 'منتج جديد',
    context: 'كل معلومات المنتج في صفحة واحدة',
    createdBy: 'أنشأه {{name}}',
    sections: 'أقسام المنتج',
    essentials: 'الأساسيات',
    pricing: 'الأسعار',
    variants: 'المتغيّرات',
    stock: 'المخزون',
    shipping: 'الشحن',
    more: 'خيارات إضافية',
    languages: 'اللغات',
    translationMissing: 'للترجمة',
    description: 'الوصف',
    origin: 'المصدر',
    originHelp: 'محلي أو مستورد، مع البلد',
    originCountry: 'مستورد من',
    originAddCountry: 'أضف بلد الاستيراد',
    originFindCountry: 'ابحث عن بلد',
    originNoCountry: 'لا يوجد بلد مطابق',
    originSeveral:
      'كل مصدر يصبح متغيّرًا بمخزون خاص به. تبقى الأسعار نفسها ما لم تفعّل «أسعار مختلفة حسب المتغيّر».',
    originRemove: 'إزالة {{origin}}',
    referenceHelp: 'مقترح انطلاقًا من الشركة الفرعية والفئة، ويمكنك تعديله. فريد في متجرك.',
    noCategory: 'بدون فئة',
    subCategory: 'الفئة الفرعية',
    noSubCategory: 'بدون فئة فرعية',
    sellingPrice: 'سعر البيع',
    cost: 'سعر الشراء',
    costHelp: 'مرئي فقط للأدوار المصرّح لها',
    margin: 'الهامش',
    promo: 'تفعيل التخفيض',
    regularPrice: 'السعر المشطوب',
    regularPriceHelp: 'السعر قبل التخفيض، يظهر مشطوبًا بجانب سعر البيع',
    perVariantPrice: 'أسعار مختلفة حسب المتغيّر',
    perVariantPriceHelp: 'يُدخل سعر الشراء وسعر البيع على كل متغيّر (مثال: مصدر محلي أو مستورد)',
    barcode: 'الباركود',
    stockHelp: 'يتغيّر المخزون فقط عبر الحركات، للحفاظ على التتبّع.',
    weight: 'الوزن',
    unitKg: 'كغ',
    unitCm: 'سم',
    lengthCm: 'الطول',
    widthCm: 'العرض',
    heightCm: 'الارتفاع',
    weightHelp: 'يُطبّق على كل المتغيّرات',
    warranty: 'الضمان (أشهر)',
    saveDraft: 'حفظ المسودة',
    publish: 'تفعيل',
    deactivate: 'إلغاء التفعيل',
    archivedNotice: 'منتج مؤرشف: لم يعد يظهر في القوائم ولا في الطلبات.',
    restore: 'إرجاع إلى مسودة',
    undo: 'تراجع',
    errorsTitle: 'صحّح هذه النقاط قبل الحفظ',
    fixField: 'الانتقال إلى الحقل',
    unsavedChanges: 'بعض التعديلات غير محفوظة. إذا غادرت فستضيع.',
    leaveTitle: 'مغادرة المحرّر؟',
    leave: 'المغادرة دون حفظ',
    stay: 'البقاء',
    notFound: 'تعذّر العثور على هذا المنتج.',
    backToProducts: 'العودة إلى المنتجات',
    outcome_created: 'تم إنشاء المنتج',
    outcome_saved: 'تم حفظ المنتج',
    outcome_published: 'تم تفعيل المنتج',
    outcome_deactivated: 'تم إلغاء تفعيل المنتج',
    hasOptions: 'لهذا المنتج خيارات (اللون، المقاس…)',
    hasOptionsHelp: 'كل تركيبة من القيم تصبح متغيّرًا له رمز SKU ومخزون خاصّان.',
    optionsHelp: 'حدّد القيم المتوفّرة لهذا المنتج. كل تركيبة تصبح متغيّرًا.',
    newOptionName: 'خيار جديد (مثال: الخامة)',
    createOption: 'إنشاء الخيار',
    newValueFor: 'قيمة جديدة لـ {{option}}',
    addValue: 'إضافة القيمة',
    valuesChosen_zero: 'لا قيمة محدّدة',
    valuesChosen_one: 'قيمة واحدة محدّدة',
    valuesChosen_two: 'قيمتان محدّدتان',
    valuesChosen_few: '{{count}} قيم محدّدة',
    valuesChosen_many: '{{count}} قيمة محدّدة',
    valuesChosen_other: '{{count}} قيمة محدّدة',
    optionLimit: '3 خيارات كحدّ أقصى لكل منتج',
    variantsOnSale: 'المتغيّرات المعروضة للبيع: {{count}}',
    singleVariant: 'متغيّر وحيد',
    stockTotal: 'الكمية الإجمالية',
    stockAddVariant: 'إضافة متغيّر',
    stockSplitVariant: 'المتغيّر',
    stockSplitQuantity: 'الكمية',
    stockSplitRemove: 'إزالة سطر المتغيّر {{position}}',
    stockSplitHelp_zero: 'تُوزَّع بالتساوي على المتغيّرات',
    stockSplitHelp_one: 'تُوزَّع على متغيّر واحد',
    stockSplitHelp_two: 'تُوزَّع بالتساوي على المتغيّرين',
    stockSplitHelp_few: 'تُوزَّع بالتساوي على {{count}} متغيّرات',
    stockSplitHelp_many: 'تُوزَّع بالتساوي على {{count}} متغيّرًا',
    stockSplitHelp_other: 'تُوزَّع بالتساوي على {{count}} متغيّر',
    stockAddDepot: 'إضافة مستودع:',
    stockDepots: 'مستودعات هذا المنتج',
    stockDefault: 'افتراضي',
    stockDropDepot: 'إزالة {{depot}}',
    stockGrandTotal_zero: 'المجموع: {{total}} وحدة في {{depots}} مستودعات',
    stockGrandTotal_one: 'المجموع: وحدة واحدة في {{depots}} مستودعات',
    stockGrandTotal_two: 'المجموع: وحدتان في {{depots}} مستودعات',
    stockGrandTotal_few: 'المجموع: {{total}} وحدات في {{depots}} مستودعات',
    stockGrandTotal_many: 'المجموع: {{total}} وحدة في {{depots}} مستودعات',
    stockGrandTotal_other: 'المجموع: {{total}} وحدة في {{depots}} مستودعات',
    stockThreshold: 'حدّ التنبيه',
    stockThresholdHelp: 'تصلك تنبيهات عندما يبلغ المخزون المتاح هذا المستوى.',
    stockThresholdPlaceholder: 'مثال: 5',
    skuHelp: 'اتركه فارغًا لاستعمال الرمز المقترح',
    initialStockHelp: 'أدخل المخزون الابتدائي للمتغيّرات التي لا حركة لها بعد. يُسجَّل مع المنتج.',
    initialStockFailed: 'تم حفظ المنتج، لكن لم يُسجَّل مخزونه الابتدائي:',
    autosave_saving: 'جارٍ الحفظ…',
    autosave_saved: 'تم حفظ المسودة',
    autosave_failed: 'فشل الحفظ التلقائي',
    errors: {
      FINANCE_REMITTED_BEFORE_DELIVERY:
        'أبلغت شركة التوصيل عن الدفع قبل التسليم؛ سيُحتسب بمجرد تأكيد التسليم.',
      nameRequired: 'الاسم إلزامي باللغة الافتراضية للمتجر.',
      priceInvalid: 'أدخل مبلغًا موجبًا بثلاثة أرقام عشرية على الأكثر.',
      regularPriceTooLow: 'يجب أن يكون السعر المشطوب أعلى من سعر البيع.',
      priceBelowCost: 'يجب أن يكون سعر البيع أكبر من سعر الشراء أو مساويًا له.',
      variantRequired: 'أضف متغيّرًا واحدًا على الأقل.',
      referenceRequired: 'المرجع إلزامي.',
      weightInvalid: 'أدخل وزنًا بالكيلوغرام بثلاثة أرقام عشرية على الأكثر.',
      warrantyInvalid: 'أدخل عددًا صحيحًا من الأشهر، بين 1 و600.',
      optionValuesRequired: 'اختر خيارًا وقيمة واحدة على الأقل.',
      quantityInvalid: 'أدخل عددًا صحيحًا من 0 إلى 100000.',
      stockRequired: 'أدخل وحدة واحدة على الأقل في مخزون أحد المستودعات.',
      dimensionInvalid: 'أدخل بُعدًا بالسنتيمتر، مثال 12.5',
      splitMismatch: 'يجب أن يساوي مجموع كميات المتغيّرات الكمية الإجمالية للمستودع.',
    },
  },
  categoryList: {
    detailPlacement: 'الموضع',
    detailPlacementHint: 'مكان هذا الصنف في المتجر.',
    detailTranslationsHint: 'الاسم والعنوان المعروضان في كل لغة.',
    status_active: 'نشطة',
    status_archived: 'مؤرشفة',
    productsUnit_zero: 'منتج',
    productsUnit_one: 'منتج',
    productsUnit_two: 'منتجان',
    productsUnit_few: 'منتجات',
    productsUnit_many: 'منتجًا',
    productsUnit_other: 'منتج',
    summaryRoots_zero: 'لا أقسام',
    summaryRoots_one: 'قسم واحد',
    summaryRoots_two: 'قسمان',
    summaryRoots_few: '{{total}} أقسام',
    summaryRoots_many: '{{total}} قسمًا',
    summaryRoots_other: '{{total}} قسم',
    summaryChildren_zero: 'لا فئات فرعية',
    summaryChildren_one: 'فئة فرعية واحدة',
    summaryChildren_two: 'فئتان فرعيتان',
    summaryChildren_few: '{{total}} فئات فرعية',
    summaryChildren_many: '{{total}} فئة فرعية',
    summaryChildren_other: '{{total}} فئة فرعية',
    summaryProducts_zero: 'لا منتجات',
    summaryProducts_one: 'منتج واحد',
    summaryProducts_two: 'منتجان',
    summaryProducts_few: '{{total}} منتجات',
    summaryProducts_many: '{{total}} منتجًا',
    summaryProducts_other: '{{total}} منتج',
    summaryArchived_zero: 'لا فئات مؤرشفة',
    summaryArchived_one: 'فئة مؤرشفة واحدة',
    summaryArchived_two: 'فئتان مؤرشفتان',
    summaryArchived_few: '{{total}} فئات مؤرشفة',
    summaryArchived_many: '{{total}} فئة مؤرشفة',
    summaryArchived_other: '{{total}} فئة مؤرشفة',
    nameIn: 'الاسم بـ{{language}}',
    nameRequiredIn: 'إلزامي: يعرضه المتجر افتراضيًا.',
    nameFallback: 'اختياري. بدون ترجمة، يعرض المتجر الاسم بـ{{language}}.',
    address: 'العنوان',
    addressPending: 'يُنشأ عند الحفظ',
    addressHelp: 'مُنشأ من الاسم بـ{{language}}.',
    search: 'البحث عن فئة',
    view_active: 'النشطة',
    view_archived: 'المؤرشفة',
    foldAll: 'طي الكل',
    unfoldAll: 'توسيع الكل',
    toggle: 'إظهار أو إخفاء الفئات الفرعية لـ {{name}}',
    languages: 'اللغات',
    translated: 'مترجمة إلى {{language}}',
    untranslated: 'غير مترجمة إلى {{language}} بعد',
    products: 'المنتجات',
    productCount_zero: 'لا منتجات',
    productCount_one: 'منتج واحد',
    productCount_two: 'منتجان',
    productCount_few: '{{total}} منتجات',
    productCount_many: '{{total}} منتجًا',
    productCount_other: '{{total}} منتج',
    edit: 'تعديل {{name}}',
    archive: 'أرشفة {{name}}',
    noMatch: 'لا توجد فئة مطابقة',
    noMatchHelp: 'جرّب اسمًا آخر، بأي لغة.',
    coverageTitle: 'الترجمات',
    coverageHelp: 'الاسم بـ{{language}} إلزامي. بدون ترجمة، يعرض المتجر الاسم بـ{{language}}.',
    coverageCount: '{{translated}}/{{total}}',
    archiveTip: 'تختفي الفئة المؤرشفة من المتجر، وتبقى منتجاتها في الكتالوج.',
    detailParent: 'الفئة الأم',
    detailRoot: 'فئة رئيسية',
    detailPosition: 'الترتيب',
    detailTranslations: 'الاسم بكل لغة',
    detailMissing: 'لم تُترجم بعد',
    detailNoDescription: 'لا يوجد وصف',
  },
  productList: {
    details: 'عرض',
    active: 'نشط',
    adjustRow: 'عملية على {{name}}',
    edit: 'تعديل',
    kpi_unitsInDepots_zero: 'لا وحدات في {{depots}}',
    kpi_unitsInDepots_one: 'وحدة واحدة في {{depots}}',
    kpi_unitsInDepots_two: 'وحدتان في {{depots}}',
    kpi_unitsInDepots_few: '{{units}} وحدات في {{depots}}',
    kpi_unitsInDepots_many: '{{units}} وحدة في {{depots}}',
    kpi_unitsInDepots_other: '{{units}} وحدة في {{depots}}',
    kpi_depots_zero: 'لا مستودعات',
    kpi_depots_one: 'مستودع واحد',
    kpi_depots_two: 'مستودعين',
    kpi_depots_few: '{{total}} مستودعات',
    kpi_depots_many: '{{total}} مستودعًا',
    kpi_depots_other: '{{total}} مستودع',
    printLabels: 'طباعة الملصقات',
    reference: 'المرجع',
    kpi_saleValue: 'قيمة المخزون · بسعر البيع',
    kpi_costValue: 'بسعر الشراء',
    kpi_ofCatalogue: 'من أصل {{total}} في الكتالوج',
    kpi_active: 'المنتجات النشطة',
    kpi_low: 'مخزون منخفض',
    kpi_out: 'نفد المخزون',
    kpi_show: 'عرض المنتجات',
    product: 'المنتج',
    variantCount_zero: 'لا متغيرات',
    variantCount_one: 'متغير واحد',
    variantCount_two: 'متغيران',
    variantCount_few: '{{count}} متغيرات',
    variantCount_many: '{{count}} متغيرًا',
    variantCount_other: '{{count}} متغير',
    allCategories: 'كل الفئات',
    optionValue: 'الخيار',
    allOptionValues: 'كل الخيارات',
    findOptionValue: 'ابحث عن خيار (مثال: المصدر)',
    noOptionValueMatch: 'لا يوجد خيار مطابق',
    findCategory: 'ابحث عن فئة',
    noCategoryMatch: 'لا توجد فئة مطابقة',
    view: 'عرض',
    view_all: 'الكل',
    view_active: 'النشطة',
    view_draft: 'غير النشطة',
    view_archived: 'المؤرشفة',
    view_low: 'مخزون منخفض',
    view_out: 'نفد المخزون',
    view_sale: 'مبيعات',
    view_return: 'رجوع إلى المستودع',
    view_defective: 'معيبة',
    view_loss: 'خسائر',
    operationPeriod: 'فترة العمليات',
    period_last_7_days: 'آخر 7 أيام',
    period_last_30_days: 'آخر 30 يومًا',
    period_this_month: 'هذا الشهر',
    period_last_month: 'الشهر الماضي',
    period_this_year: 'هذه السنة',
    period_custom: 'تواريخ مخصّصة',
    periodFrom: 'من',
    periodTo: 'إلى',
    sort: 'ترتيب حسب',
    sort_created_desc: 'الأحدث',
    sort_created_asc: 'الأقدم',
    sort_updated_desc: 'المعدّلة مؤخرًا',
    sort_name_asc: 'الاسم (أ ← ي)',
    searchShortcut: 'اختصار: /',
    stock: 'المخزون',
    stockUnavailable: 'تعذّر تحميل المخزون.',
    selectProduct: 'تحديد {{name}}',
    selectAll: 'تحديد المنتجات المعروضة',
    shown: '{{shown}} من {{total}}',
    bulkActions: 'إجراءات على التحديد',
    selected: 'المنتجات المحدّدة: {{count}}',
    clearSelection: 'إلغاء التحديد',
  },
  productStatus: {
    published: 'المنتجات المفعّلة: {{count}}',
    deactivated: 'المنتجات الملغى تفعيلها: {{count}}',
    archived: 'المنتجات المحذوفة: {{count}}',
    restored: 'المنتجات المستعادة: {{count}}',
    failed: '{{name}}: {{reason}}',
  },
  stockValue: {
    title: 'المخزون في المستودعات',
    hint: 'بسعر البيع اليوم، مع قيمته بسعر الشراء',
    units: 'الوحدات',
    cost: 'إجمالي الشراء',
  },
  productStatistics: {
    sectionTitle: 'الإحصائيات والحركات',
    netGain: 'الربح الصافي',
    ordered: 'المطلوبة',
    delivered: 'المسلَّمة',
    manualSales: 'المبيعات اليدوية',
    carrierReturned: 'مرتجعات الناقل',
    receivedBack: 'المستلمة في المستودع',
    missing: 'المفقودة',
    missingHint: 'أرجعها الناقل لكنها لم تصل إلى المستودع أبدًا',
    defective: 'المعيبة',
    lost: 'الخسائر',
    amount: 'المبلغ',
    revenue: 'رقم المعاملات',
    cost: 'إجمالي الشراء',
    margin: 'الهامش',
    value: 'القيمة بسعر الشراء',
    chartTitle: 'التطور',
    metric_revenue: 'رقم المعاملات',
    metric_losses: 'الخسائر',
    chartLabel: '{{metric}} لكل فترة',
    historyTitle: 'سجل الحركات',
  },
  quickStock: {
    title: 'إضافة مخزون',
    onHand: 'في المخزون',
    quickAmounts: 'إضافة سريعة',
    addAmount: 'إضافة {{count}} إلى {{name}}',
    decrement: 'إنقاص وحدة من {{name}}',
    increment: 'إضافة وحدة إلى {{name}}',
    total_zero: '{{change}} وحدة',
    total_one: '{{change}} وحدة',
    total_two: '{{change}} وحدتان',
    total_few: '{{change}} وحدات',
    total_many: '{{change}} وحدة',
    total_other: '{{change}} وحدة',
    confirm: 'إضافة',
    added: 'تمت إضافة المخزون: {{change}}',
  },
  adjustStock: {
    operationHint: 'نوع الحركة المراد تسجيلها.',
    depotHint: 'المخزن الذي يتغيّر مخزونه.',
    linesHint: 'أدخل الكمية لكل نسخة معنية.',
    noteHint: 'تظهر في سجل الحركات.',
    title: 'عملية على المنتج',
    reason: 'العملية',
    reason_sale: 'بيع',
    reason_return: 'رجوع إلى المستودع',
    reason_defective: 'معيب',
    reason_loss: 'فقدان',
    reason_receipt: 'استلام',
    reason_correction: 'تصحيح الجرد',
    reasonHelp_sale: 'بيع خارج الطلبات (متجر، بث مباشر…): يزيل القطع من المخزون بسعر البيع.',
    reasonHelp_return: 'قطع مرتجعة وصلت فعلًا إلى المستودع: يعيدها إلى المخزون.',
    reasonHelp_defective: 'يزيل القطع التالفة من المخزون، مقيّمة بسعر الشراء.',
    reasonHelp_loss: 'يزيل القطع المفقودة أو المسروقة من المخزون، مقيّمة بسعر الشراء.',
    unitPrice: 'سعر البيع للوحدة',
    unitPriceInvalid: 'أدخل سعر البيع، مثال 45.000',
    quantity: 'الكمية',
    lines: 'المتغيّرات المراد تعديلها',
    products_zero: 'لا منتجات',
    products_one: 'منتج واحد',
    products_two: 'منتجان',
    products_few: '{{count}} منتجات',
    products_many: '{{count}} منتجًا',
    products_other: '{{count}} منتج',
    notePlaceholder: 'مثال: بيع في معرض 12 أكتوبر، طرد تالف في المستودع',
    after: 'بعد',
    invalid: 'يُتوقّع عدد صحيح',
    negative: 'مخزون سالب ({{after}})',
    summary: 'المتغيّرات: {{count}} · {{change}}',
    confirm: 'حفظ التعديل',
    recorded: 'الحركات المسجّلة: {{count}}',
  },
  shortcuts: {
    title: 'اختصارات لوحة المفاتيح',
    next: 'المنتج التالي',
    previous: 'المنتج السابق',
    open: 'معاينة المنتج',
    edit: 'تعديل المنتج',
    adjust: 'عملية على المنتج',
    select: 'تحديد المنتج',
    search: 'بحث',
    help: 'عرض هذه المساعدة',
    close: 'إغلاق أو إلغاء التحديد',
  },
  productImport: {
    openCsv: 'استيراد (CSV)',
    open: 'استيراد',
    title: 'استيراد المنتجات',
    drop: 'أفلت ملف CSV هنا أو انقر لاختياره',
    dropHelp: 'سطر لكل متغيّر؛ الأسطر ذات المرجع نفسه تشكّل منتجًا واحدًا. ترميز UTF-8، والفاصل ; أو ,',
    template: 'تنزيل النموذج',
    notCsv: '{{name}} ليس ملف CSV.',
    unreadable: 'تعذّرت قراءة ملف CSV هذا: احفظه من جديد بصيغة CSV UTF-8 من جدول البيانات.',
    mappingHelp: 'حدّد محتوى كل عمود. الأعمدة المتجاهَلة لا تُستورد.',
    columns: 'أعمدة الملف',
    unnamedColumn: 'العمود {{position}}',
    importAs: 'استيراد «{{column}}» بصفته',
    field_ignore: 'عدم الاستيراد',
    field_reference: 'المرجع',
    field_category: 'الفئة',
    field_sku: 'SKU',
    field_barcode: 'الرمز الشريطي',
    field_price: 'سعر البيع',
    field_regularPrice: 'السعر المشطوب',
    field_cost: 'تكلفة الشراء',
    field_weightKg: 'الوزن (كغ)',
    field_stock: 'المخزون الأولي',
    field_option: 'خيار (اسم العمود)',
    field_name_in: 'الاسم ({{locale}})',
    field_description_in: 'الوصف ({{locale}})',
    depot: 'مستودع المخزون الأولي',
    chooseDepot: 'اختر مستودعًا',
    problem_reference: 'اربط عمودًا بالمرجع.',
    problem_price: 'اربط عمودًا بسعر البيع.',
    problem_name: 'اربط عمودًا بالاسم باللغة {{locale}}، لغة المتجر.',
    problem_duplicate: 'عمودان مربوطان بالحقل نفسه.',
    problem_options: 'ثلاثة أعمدة خيارات على الأكثر.',
    otherFile: 'اختيار ملف آخر',
    check: 'فحص الملف',
    working_checking: 'جارٍ إرسال الملف وفحصه…',
    working_applying: 'جارٍ إنشاء المنتجات…',
    ready: 'المنتجات الجاهزة: {{count}}',
    toFix: 'الأسطر المطلوب تصحيحها: {{count}}',
    rowsRead: 'الأسطر المقروءة: {{count}}',
    moreErrors: 'و{{count}} أخطاء أخرى غير معروضة.',
    row: 'السطر',
    column: 'العمود',
    problem: 'المشكلة',
    value: 'القيمة',
    error_required: 'قيمة إلزامية مفقودة',
    error_invalid_decimal: 'رقم غير صالح (مثال 79,500)',
    error_invalid_integer: 'يُتوقّع عدد صحيح',
    error_formula: 'صيغة جدول بيانات مرفوضة',
    error_too_long: 'نص طويل جدًا',
    error_inconsistent_product: 'أسطر هذا المرجع غير متطابقة',
    error_mixed_options: 'المتغيّرات لا تحمل الخيارات نفسها',
    error_duplicate_variant: 'متغيّر مكرّر',
    error_duplicate_sku: 'SKU مستعمل مرتين في الملف',
    error_reference_taken: 'المرجع مستعمل في الكتالوج',
    error_sku_taken: 'SKU مستعمل في الكتالوج',
    error_unknown_category: 'فئة غير معروفة',
    error_header_mismatch: 'تغيّر ترويس الملف',
    error_too_many_rows: 'الملف طويل جدًا',
    apply: 'استيراد المنتجات الجاهزة ({{count}})',
    issues: 'الأسطر المطلوب تصحيحها',
    issueWhere: 'السطر {{row}} · العمود {{column}}',
    created: 'المنتجات المنشأة: {{count}}',
    failed: 'تعذّر إكمال الاستيراد',
    draftsHelp: 'المنتجات المستوردة غير نشطة: راجعها ثم فعّلها.',
    failures: 'منتجات لم تُنشأ',
    failure: '{{reference}} ({{stage}}): {{reason}}',
    stage_product: 'الإنشاء',
    stage_stock: 'المخزون الأولي',
  },
  quickView: {
    edit: 'تحرير',
    noCategory: 'بدون فئة',
    noImage: 'لا توجد صورة',
  },
  stockMatrix: {
    threshold: 'الحد الأدنى',
    caption: 'المخزون حسب المتغيّر والمستودع',
    total: 'المجموع',
    low: 'مخزون منخفض',
    out: 'نفاد',
    shownTotal: 'المجموع المعروض',
    legend_ok: 'متوفر',
    legend_low: 'مخزون منخفض (الحد الأدنى أو أقل)',
    legend_out: 'نفاد',
  },
  inventory: {
    depotColumns: 'المخازن',
    depotColumnsAll: 'الكل ({{count}})',
    depotColumnsSome: '{{shown}} من {{total}}',
    depotColumnsStocked: 'بها مخزون',
    levelsTab: 'مستويات المخزون',
    allMovements: 'الكل',
    variantAndDepot: 'المتغيّر · المستودع',
    movementsShown_zero: '{{shown}} من {{total}} حركة',
    movementsShown_one: '{{shown}} من حركة واحدة',
    movementsShown_two: '{{shown}} من حركتين',
    movementsShown_few: '{{shown}} من {{total}} حركات',
    movementsShown_many: '{{shown}} من {{total}} حركة',
    movementsShown_other: '{{shown}} من {{total}} حركة',
    unitsAvailable: 'الوحدات المتوفرة',
    levelsSearchLabel: 'البحث في المخزون',
    levelsSearch: 'المنتج أو المرجع أو SKU',
    allDepots: 'كل المستودعات',
    restockOnly: 'المخزون المنخفض فقط',
    levelsShown_zero: 'لا متغيرات معروضة من {{total}}',
    levelsShown_one: 'متغير واحد معروض من {{total}}',
    levelsShown_two: 'متغيران معروضان من {{total}}',
    levelsShown_few: '{{shown}} متغيرات معروضة من {{total}}',
    levelsShown_many: '{{shown}} متغيرًا معروضًا من {{total}}',
    levelsShown_other: '{{shown}} متغير معروض من {{total}}',
    depotLow: 'متغيرات بمخزون منخفض',
    kpi_available: 'الوحدات المتاحة',
    kpi_variants: 'المتغيرات المتابعة',
    kpi_inProducts_zero: 'في لا منتجات',
    kpi_inProducts_one: 'في منتج واحد',
    kpi_inProducts_two: 'في منتجين',
    kpi_inProducts_few: 'في {{total}} منتجات',
    kpi_inProducts_many: 'في {{total}} منتجًا',
    kpi_inProducts_other: 'في {{total}} منتج',
    kpi_low: 'مخزون منخفض',
    kpi_lowHint: 'تحت حد التنبيه',
    kpi_out: 'نفد المخزون',
    kpi_outHint: 'لم تبق أي وحدة',
    searchVariant: 'البحث عن منتج',
    search: 'بحث',
    searchFirst: 'ابحث عن منتج بالاسم أو المرجع أو رمز SKU',
    context: 'المستودعات والمستويات حسب المتغيّر وسجل الحركات.',
    movementsTab: 'الحركات',
    depotsTab: 'المستودعات',
    variant: 'المتغيّر',
    variantRequired: 'اختر متغيّرًا',
    noVariants: 'لا يوجد متغيّر متاح',
    depot: 'المستودع',
    depotRequired: 'اختر مستودعًا',
    depotName: 'الاسم',
    depotCode: 'الرمز',
    defaultDepot: 'افتراضي',
    yes: 'نعم',
    onHand: 'في المخزون',
    available: 'متاح',
    threshold: 'الحد',
    occurredAt: 'التاريخ',
    kind: 'النوع',
    kind_restock: 'تزويد',
    kind_restock_pending: 'تزويد معلّق',
    kind_commit: 'خروج',
    kind_write_off: 'إتلاف',
    kind_adjustment: 'تعديل',
    kind_import: 'استيراد',
    quantity: 'الكمية',
    quantityHelp: 'الاتجاه يحدده نوع الحركة',
    quantityRequired: 'يجب أن تكون الكمية عددًا صحيحًا موجبًا',
    note: 'ملاحظة',
    state: 'الحالة',
    state_applied: 'مطبّقة',
    state_pending: 'معلّقة',
    state_voided: 'ملغاة',
    newMovement: 'حركة جديدة',
    movementRecorded: 'تم تسجيل الحركة',
    loadFailed: 'تعذّر التحميل',
    noMovements: 'لا توجد حركات',
    noMovementsHelp: 'سجّل أول حركة لتعبئة السجل.',
    noDepots: 'لا توجد مستودعات',
    noDepotsHelp: 'أنشئ مستودعًا لبدء تتبّع مخزونك.',
  },
  customers: {
    identitySection: 'الهوية',
    identityHint: 'كيف تتواصل مع هذا الحريف.',
    addressSection: 'عنوان التوصيل',
    addressHint: 'يُملأ تلقائيًا في كل طلب جديد.',
    notesSection: 'ملاحظات',
    context: 'دفتر حرفائك: الهاتف والعنوان وملاحظات التوصيل.',
    newCustomer: 'حريف جديد',
    editCustomer: 'تعديل الحريف',
    customer: 'بطاقة الحريف',
    edit: 'تعديل',
    name: 'الاسم الكامل',
    phone: 'الهاتف',
    phoneHelp: 'رقم محلي أو دولي، مثال: 98 123 456',
    secondPhone: 'هاتف ثانٍ',
    email: 'البريد الإلكتروني',
    address: 'العنوان',
    governorate: 'الولاية',
    city: 'المدينة',
    postalCode: 'الترقيم البريدي',
    notes: 'ملاحظات',
    notesHelp: 'تعليمات مفيدة للموزّع أو للفريق.',
    createdAt: 'تاريخ الإنشاء',
    searchPhone: 'البحث برقم الهاتف',
    search: 'بحث',
    clearSearch: 'مسح',
    noCustomers: 'لا يوجد حرفاء بعد',
    noCustomersHelp: 'أضف حريفك الأول؛ الطلبات ستضيفهم أيضًا.',
    noMatch: 'لم يُعثر على أي حريف',
    noMatchHelp: 'تحقّق من الرقم أو من عوامل التصفية.',
    saved: 'تم حفظ الحريف',
    savedWithOrders_zero: 'تم حفظ الحريف',
    savedWithOrders_one: 'تم حفظ الحريف وتحديث طلبية واحدة لم تُسلَّم بعد لشركة التوصيل',
    savedWithOrders_two: 'تم حفظ الحريف وتحديث طلبيتين لم تُسلَّما بعد لشركة التوصيل',
    savedWithOrders_few: 'تم حفظ الحريف وتحديث {{count}} طلبيات لم تُسلَّم بعد لشركة التوصيل',
    savedWithOrders_many: 'تم حفظ الحريف وتحديث {{count}} طلبية لم تُسلَّم بعد لشركة التوصيل',
    savedWithOrders_other: 'تم حفظ الحريف وتحديث {{count}} طلبية لم تُسلَّم بعد لشركة التوصيل',
    masked: 'البيانات الشخصية مخفية حسب دورك.',
    phoneTaken: 'هذا الرقم مستعمل من طرف حريف آخر.',
    openExisting: 'فتح البطاقة',
    nameRequired: 'الاسم إجباري.',
    phoneRequired: 'الهاتف إجباري.',
    phoneInvalid: 'هذا الرقم غير صالح لبلد المتجر، مثال: 98 123 456.',
    emailInvalid: 'عنوان البريد الإلكتروني غير صالح.',
    fieldInvalid: 'هذه القيمة غير مقبولة.',
    shown: 'الحرفاء المعروضون: {{shown}} من {{total}}',
  },
  depots: {
    identitySection: 'المخزن',
    identityHint: 'كيف يظهر هذا المخزن في التطبيق.',
    placeSection: 'الاتصال والعنوان',
    placeHint: 'أين يوجد المخزن وكيف تتواصل معه.',
    settingsSection: 'الإعدادات',
    defaultSwitch: 'المستودع الافتراضي',
    add: 'مستودع جديد',
    newTitle: 'مستودع جديد',
    count_zero: 'لا مستودعات',
    count_one: 'مستودع واحد',
    count_two: 'مستودعان',
    count_few: '{{count}} مستودعات',
    count_many: '{{count}} مستودعًا',
    count_other: '{{count}} مستودع',
    figures: 'أرقام المستودع {{name}}',
    saleValue: 'قيمة البيع',
    showMovements: 'عرض حركات هذا المستودع',
    nameRequired: 'الاسم إلزامي',
    codeRequired: 'الرمز إلزامي',
    codeHelp: 'قصير وفريد، مثلًا TUN أو SFX.',
    phone: 'الهاتف',
    address: 'العنوان',
    city: 'المدينة',
    tooLong: 'هذا النص طويل جدًا',
    defaultHelp: 'المستودع المستعمل افتراضيًا للطلبات ولإدخالات المخزون.',
    defaultKept: 'هذا هو المستودع الافتراضي: اختر مستودعًا آخر لتعويضه.',
    editRow: 'تعديل {{name}}',
    archiveRow: 'أرشفة {{name}}',
    archiveTitle: 'أرشفة {{name}}؟',
    archiveMessage:
      'لن يظهر المستودع بعد الآن في الطلبات ولا في الحركات. يُحفظ سجله. لا يمكن أرشفة مستودع ما زال يحتوي على مخزون.',
    archive: 'أرشفة',
    archived: 'تمت أرشفة {{name}}',
    created: 'تم إنشاء {{name}}',
    saved: 'تم حفظ {{name}}',
  },
  companies: {
    all: 'كل الشركات',
    label: 'الشركة',
    main: '{{name}} (الشركة الرئيسية)',
    orderHelp: 'تحدد الشركة منتجات الطلب وحساب شركة النقل الذي يشحنه.',
  },
  subsidiaries: {
    title: 'الشركات الفرعية',
    context: 'شركات المتجر، المستعملة في المنتجات والطلبات والمصاريف وحسابات شركات النقل.',
    archived: 'مؤرشفة',
    none: 'لا توجد شركة فرعية',
    noneHelp: 'تُضاف الشركات الفرعية عبر واجهة البرمجة.',
    noDetails: 'لا توجد بيانات اتصال',
  },
  team: {
    title: 'الفريق',
    context: 'الأشخاص الذين يعملون في المتجر وما يمكنهم فعله.',
    invite: 'دعوة شخص',
    you: 'أنت',
    preset_admin: 'مسؤول',
    preset_staff: 'فريق العمل',
    preset_viewer: 'قراءة فقط',
    presetHelp_admin: 'إدارة كل شيء، بما في ذلك الفريق والإعدادات.',
    presetHelp_staff: 'الطلبات والشحن والمخزون يوميًا.',
    presetHelp_viewer: 'الاطلاع دون أي تعديل.',
    noPreset: 'صلاحيات تُدار في مكان آخر',
    status_pending: 'أُرسلت الدعوة',
    status_paused: 'موقوف مؤقتًا',
    outside: 'يُدار خارج البوابة',
    access: 'مستوى الصلاحيات',
    extra: 'صلاحيات إضافية',
    extraHelp: 'تُضاف إلى صلاحيات المستوى المختار.',
    group_orders: 'الطلبات',
    group_catalog: 'الكتالوج',
    group_stock: 'المخزون',
    group_finance: 'المالية',
    group_settings: 'الإعدادات',
    email: 'البريد الإلكتروني',
    firstName: 'الاسم',
    lastName: 'اللقب',
    subsidiary: 'الشركة الفرعية',
    noSubsidiary: 'لا شيء',
    inviteTitle: 'دعوة شخص',
    inviteSubmit: 'إرسال الدعوة',
    inviteHelp: 'يتلقى الشخص بريدًا لاختيار كلمة المرور. الرابط صالح لمدة 3 أيام.',
    invited: 'أُرسلت الدعوة إلى {{email}}',
    invitedNoEmail: 'لدى {{name}} صلاحية الدخول، لكن البريد لم يُرسل. أعد إرساله من بطاقته.',
    added: 'استعاد {{name}} الدخول إلى المتجر',
    emailInvalid: 'أدخل بريدًا إلكترونيًا صحيحًا.',
    firstNameRequired: 'أدخل الاسم.',
    saved: 'حُفظت صلاحيات {{name}}',
    pause: 'إيقاف مؤقت',
    resume: 'إعادة التفعيل',
    paused: '{{name}} موقوف مؤقتًا',
    resumed: 'استعاد {{name}} الدخول',
    pauseTitle: 'إيقاف {{name}} مؤقتًا؟',
    pauseMessage: 'يُسجَّل خروج الشخص فورًا ولا يمكنه الدخول حتى إعادة تفعيله.',
    remove: 'إزالة من المتجر',
    removeTitle: 'إزالة {{name}}؟',
    removeMessage: 'يفقد الشخص كل صلاحياته في المتجر. يبقى اسمه في السجل.',
    removed: 'أُزيل {{name}} من المتجر',
    resend: 'إعادة إرسال الدعوة',
    resent: 'أعيد إرسال الدعوة إلى {{email}}',
    selfNote: 'لتغيير صلاحياتك، اطلب ذلك من مسؤول آخر.',
    perm_orders_write: 'إنشاء الطلبات وتعديلها',
    perm_orders_confirm: 'تأكيد الطلبات',
    perm_orders_dispatch: 'تسليم الطلبات لشركات التوصيل وطباعة الملصقات',
    perm_orders_pii_read: 'رؤية هواتف الزبائن وعناوينهم',
    perm_orders_refund: 'الاسترجاع',
    perm_catalog_write: 'إدارة المنتجات والأصناف',
    perm_catalog_cost: 'رؤية أسعار الشراء',
    perm_inventory_write: 'تسجيل حركات المخزون',
    perm_finance_read: 'رؤية المالية',
    perm_finance_write: 'إدارة المصاريف والتحويلات',
    perm_carriers_manage: 'إدارة شركات التوصيل',
    perm_settings_manage: 'إدارة إعدادات المتجر',
    perm_users_manage: 'إدارة الفريق',
    perm_audit_read: 'الاطلاع على سجل التعديلات',
  },
  history: {
    title: 'السجل',
    context: 'من عدّل ماذا في المتجر، ومتى.',
    sectionContext:
      'كل تعديل تم في المتجر: الفريق والشركات الفرعية والمنتجات والأصناف والمخازن وإعدادات الطلبات والمصاريف.',
    openPage: 'فتح السجل',
    kindLegend: 'نوع التعديل',
    kind_all: 'الكل',
    kind_people: 'الفريق',
    kind_subsidiaries: 'الشركات الفرعية',
    kind_products: 'المنتجات',
    kind_categories: 'الأصناف',
    kind_depots: 'المخازن',
    kind_settings: 'الإعدادات',
    kind_finance: 'المصاريف',
    kind_exports: 'التصديرات',
    from: 'من',
    to: 'إلى',
    byActor: 'تعديلات {{name}}',
    byChosenActor: 'تعديلات الشخص المختار',
    everyone: 'عرض الجميع',
    onlyActor: 'عرض تعديلات {{name}} فقط',
    open: 'فتح',
    openSubject: 'فتح {{subject}}',
    before: 'قبل',
    after: 'بعد',
    loading: 'جارٍ تحميل السجل',
    shown: 'عرض {{count}} من {{total}} تعديل',
    empty: 'لا توجد تعديلات بعد',
    emptyHint: 'ستظهر هنا التعديلات التي تتم في المتجر.',
    emptyFiltered: 'لا توجد تعديلات تطابق هذه المرشحات',
    emptyFilteredHint: 'وسّع الفترة أو اختر نوعًا آخر.',
    clearFilters: 'مسح المرشحات',
    actor_person: 'عضو في الفريق',
    actor_system: 'النظام',
    actor_support: 'دعم Al-WidadiaShop',
    actor_unknown: 'مستخدم محذوف',
    subject_unnamed: 'بدون اسم',
    action_order_export_requested: 'صدّر الطلبات',
    action_other: 'تعديل «{{subject}}»',
    action_team_member_invited: 'دعوة {{subject}} إلى الفريق',
    action_team_member_access_changed: 'تغيير صلاحيات {{subject}}',
    action_team_member_paused: 'إيقاف وصول {{subject}}',
    action_team_member_resumed: 'إعادة وصول {{subject}}',
    action_team_member_removed: 'إزالة {{subject}} من الفريق',
    action_team_member_renamed: 'غيّر الاسم إلى {{subject}}',
    action_user_account_sessions_ended: 'سجّل الخروج من الأجهزة الأخرى',
    field_endedSessions: 'الجلسات المغلقة',
    action_subsidiary_created: 'إضافة الشركة الفرعية «{{subject}}»',
    action_subsidiary_revised: 'تعديل الشركة الفرعية «{{subject}}»',
    action_subsidiary_archived: 'أرشفة الشركة الفرعية «{{subject}}»',
    action_subsidiary_restored: 'استعادة الشركة الفرعية «{{subject}}»',
    action_product_created: 'إنشاء المنتج «{{subject}}»',
    action_product_revised: 'تعديل المنتج «{{subject}}»',
    action_product_active: 'نشر المنتج «{{subject}}»',
    action_product_draft: 'إعادة المنتج «{{subject}}» إلى المسودة',
    action_product_archived: 'أرشفة المنتج «{{subject}}»',
    action_category_created: 'إنشاء الصنف «{{subject}}»',
    action_category_revised: 'تعديل الصنف «{{subject}}»',
    action_category_archived: 'أرشفة الصنف «{{subject}}»',
    action_location_created: 'إضافة المخزن «{{subject}}»',
    action_location_archived: 'أرشفة المخزن «{{subject}}»',
    action_order_settings_revised: 'تغيير مهلة تأكيد الطلبات',
    action_tenant_profile_revised: 'عدّل معلومات المتجر {{subject}}',
    action_tenant_branding_revised: 'عدّل شعار المتجر وألوانه',
    field_defaultLocale: 'اللغة الافتراضية',
    field_timezone: 'المنطقة الزمنية',
    field_logoMediaId: 'الشعار',
    field_primaryColor: 'اللون الرئيسي',
    field_secondaryColor: 'اللون الثانوي',
    field_accentColor: 'لون التمييز',
    action_expense_created: 'إضافة المصروف «{{subject}}»',
    action_expense_revised: 'تعديل المصروف «{{subject}}»',
    action_expense_archived: 'أرشفة المصروف «{{subject}}»',
    action_expense_restored: 'استعادة المصروف «{{subject}}»',
    field_other: 'معلومة أخرى',
    field_displayName: 'الاسم',
    field_preset: 'الصلاحيات',
    field_subsidiaryId: 'الشركة الفرعية',
    field_status: 'الحالة',
    field_name: 'الاسم',
    field_taxId: 'المعرّف الجبائي',
    field_phone: 'الهاتف',
    field_address: 'العنوان',
    field_city: 'المدينة',
    field_archived: 'مؤرشف',
    field_reference: 'المرجع',
    field_categoryId: 'الصنف',
    field_price: 'السعر',
    field_compareAtPrice: 'السعر قبل التخفيض',
    field_variantCount: 'عدد المتغيرات',
    field_parentId: 'الصنف الأب',
    field_code: 'الرمز',
    field_isDefault: 'المخزن الافتراضي',
    field_orderConfirmationTtlHours: 'مهلة التأكيد',
    field_amount: 'المبلغ',
    field_spentOn: 'تاريخ المصروف',
    status_draft: 'غير نشط',
    status_active: 'نشط',
    status_archived: 'مؤرشف',
    status_paused: 'موقوف',
    status_removed: 'مُزال',
    value_yes: 'نعم',
    value_no: 'لا',
    value_none: 'لا شيء',
    value_other: 'محذوف أو مؤرشف',
  },
  labels: {
    firstProducts: 'يتم تحضير ملصقات أول {{max}} منتجات محددة فقط.',
    title: 'الملصقات',
    context: 'اطبع ملصقات بشفرة خطية أو رمز QR للمتغيرات المختارة.',
    printLabels: 'طباعة ملصقات',
    printFor: 'طباعة ملصقات {{name}}',
    format: 'الصيغة',
    format_sheet: 'ورقة A4 (24 × 70 × 37 مم)',
    format_roll: 'لفافة (50 × 30 مم)',
    symbology: 'الرمز',
    symbology_code128: 'شفرة خطية',
    symbology_qr: 'رمز QR',
    showPrice: 'إظهار السعر',
    startAt: 'البدء من الموضع',
    startAtHelp: 'من 1 إلى {{count}}، لإعادة استعمال ورقة مستعملة جزئيًا.',
    copiesOf: 'عدد الملصقات لـ {{name}}',
    summary: 'الملصقات: {{stickers}} · الصفحات: {{pages}}',
    print: 'طباعة',
    tooMany: '{{max}} ملصق على الأكثر في كل طباعة. خفّض الكميات.',
    unprintable:
      '{{count}} متغير بدون رمز مطبوع: المرجع طويل جدًا أو يحتوي على أحرف غير مدعومة. اختر رمز QR.',
    preview: 'معاينة الصفحة الأولى',
    previewEmpty: 'حدّد ملصقًا واحدًا على الأقل لرؤية المعاينة.',
    nothing: 'لم يتم اختيار أي منتج',
    nothingHint: 'اختر منتجات من القائمة ثم اضغط «طباعة ملصقات».',
    chooseProducts: 'اختيار منتجات',
    loading: 'تحضير الملصقات',
    codeUnsupported: 'رمز غير ممكن',
    codeTooLong: 'رمز طويل جدًا',
  },
  notifications: {
    filterLegend: 'عرض',
    filter_all: 'الكل',
    filter_unread: 'غير المقروءة',
    sectionNew: 'جديدة',
    sectionEarlier: 'أقدم',
    seePrevious: 'عرض الإشعارات السابقة',
    seeAll: 'عرض كل الإشعارات',
    pageContext: 'تنبيهات المخزون والناقلين وملخص الساعة 8 صباحًا.',
    allRead: 'تمت قراءة كل شيء',
    allReadHelp: 'ستظهر التنبيهات الجديدة هنا.',
    title: 'الإشعارات',
    bell: 'الإشعارات',
    bellUnseen: 'الإشعارات، {{count}} جديدة',
    announce: 'إشعارات جديدة: {{count}}',
    markAllRead: 'تحديد الكل كمقروء',
    unread: 'غير مقروء',
    empty: 'لا شيء يُذكر',
    emptyHelp: 'ستظهر هنا تنبيهات المخزون وشركات التوصيل وملخص الساعة الثامنة صباحًا.',
    unknownReason: 'سبب غير محدد',
    stock_low_title: 'مخزون منخفض: {{product}}',
    stock_low_detail: '{{sku}} في {{depot}}: بقي {{available}} (الحد {{threshold}}).',
    stock_out_title: 'نفاد المخزون: {{product}}',
    stock_out_detail: 'لم يعد {{sku}} متوفرًا في {{depot}}.',
    dispatch_failed_title: 'طرد مرفوض: {{number}}',
    dispatch_failed_detail: 'لم تسجّل شركة التوصيل الطرد: {{reason}}',
    carrier_canceled_title: 'طرد ألغته شركة التوصيل: {{number}}',
    carrier_canceled_detail: 'تحقق من الطلب وأعد إرساله عند الحاجة.',
    daily_digest_title: 'ملخص يوم {{day}}',
    digest_missing: 'مفقودة: {{count}}',
    digest_deliveryFailed: 'محاولات توصيل فاشلة: {{count}}',
    digest_returnsToReceive: 'مرتجعات بانتظار الاستلام: {{count}}',
  },
  orderBulk: {
    cancel: 'إلغاء الطلبات',
    cancelHereOnly: 'هذه الطلبات لم تُسلَّم بعد لشركة توصيل: تُلغى هنا فقط.',
    title_cancel: 'إلغاء جماعي',
    cancelTitle: 'إلغاء الطلبات المحددة: {{count}}',
    cancelMessage:
      'يعود المخزون المحجوز متاحًا. لا يمكن استئناف طلب ملغى. الطلبات التي تعذّر إلغاؤها تُعرض بعد ذلك مع السبب.',
    cancelAtCarrier: 'طرود سُلّمت لشركة التوصيل: {{count}}. تُحذف لديها أيضًا ما دامت لم تستلمها بعد.',
    cancelConfirm: 'إلغاء الطلبات ({{count}})',
    keepOrders: 'الاحتفاظ بالطلبات',
    handedOver: 'سُلّمت لشركة التوصيل: {{count}}',
    awaitingCarrier: 'في انتظار رد شركة التوصيل: {{count}}',
    retryDispatch: 'إعادة محاولة التسليم ({{count}})',
    nothingEligible: 'لا يوجد طلب محدد يسمح بهذا الإجراء.',
    working: 'جارٍ التنفيذ…',
    notFoundTitle: 'طرود غير موجودة',
    notReadyTitle: 'غير جاهزة بعد: لم تسجّل شركة التوصيل هذه الطرود',
    separateTitle: 'ملصقات تصنعها شركة التوصيل، تُنزَّل واحدًا واحدًا',
    printPdf: 'طباعة',
    downloadPdf: 'تنزيل ملف PDF',
    pdfReady: 'ملصقات في ملف PDF: {{count}}',
    skipped: 'تم تجاهلها لأنها ليست في الحالة المناسبة: {{count}}',
    refusedTitle: 'طلبات لم تتم',
    refused: 'لم تتم: {{count}}',
    done: 'تمت: {{count}}',
    title_labels: 'طباعة الملصقات',
    title_dispatch: 'تسليم جماعي لشركة التوصيل',
    title_confirm: 'تأكيد جماعي',
    printLabels: 'طباعة الملصقات',
    clear: 'إلغاء التحديد',
    selected: 'الطلبات المحددة: {{count}}',
    label: 'إجراءات على التحديد',
    dispatch: 'تسليم لشركة التوصيل',
    dispatchTitle: 'تسليم لشركة التوصيل: {{count}} طلبات',
    dispatchMessage:
      'يُسلَّم كل طلب لشركة التوصيل المختارة. الطلبات التي تعذّر تسليمها تُعرض بعد ذلك مع السبب.',
    confirm: 'تأكيد',
  },
  orderExport: {
    title: 'تصدير الطلبات',
    count_zero: 'لا طلبات',
    count_one: 'طلب واحد',
    count_two: 'طلبان',
    count_few: '{{total}} طلبات',
    count_many: '{{total}} طلبًا',
    count_other: '{{total}} طلب',
    format: 'ملف CSV يُفتح في Excel و Google Sheets، بالعربية. التواريخ حسب توقيت المتجر.',
    masked: 'ستُخفى أسماء العملاء وهواتفهم وتُحذف العناوين: صلاحياتك لا تشمل بيانات العملاء.',
    prepare: 'تحضير الملف',
    preparing: 'جارٍ التحضير…',
    building: 'جارٍ تحضير الملف. يمكنك مواصلة العمل.',
    ready_zero: 'الملف جاهز: لا طلبات.',
    ready_one: 'الملف جاهز: طلب واحد.',
    ready_two: 'الملف جاهز: طلبان.',
    ready_few: 'الملف جاهز: {{total}} طلبات.',
    ready_many: 'الملف جاهز: {{total}} طلبًا.',
    ready_other: 'الملف جاهز: {{total}} طلب.',
    failed: 'تعذّر تحضير الملف. أعد المحاولة بعد قليل.',
    retry: 'إعادة المحاولة',
    download: 'تنزيل الملف',
  },
  orders: {
    dispatchFee: 'معلوم التوصيل',
    dispatchFeeOf: 'معلوم توصيل {{number}}',
    dispatchFeeInvalid: 'أدخل مبلغًا موجبًا بثلاثة أرقام عشرية على الأكثر.',
    dispatchCollect: 'المبلغ المستخلص: {{amount}}',
    carrierFeeMissing: 'لا تعريفة لهذا الناقل: أدخل المعلوم.',
    selectAll: 'تحديد كل الطلبات المعروضة',
    selectRow: 'تحديد {{number}}',
    labelPrinted: 'الملصق مطبوع',
    refreshNotFollowed: 'لم تعد شركة التوصيل تتابع هذا الطرد.',
    refreshQueued: 'أُرسل الطلب إلى شركة التوصيل؛ ستتحدث الحالة بعد قليل.',
    refresh: 'تحديث التتبع',
    view_canceled: 'ملغاة',
    view_exchanges: 'استبدالات',
    view_returns: 'مرتجعات',
    view_to_receive: 'في انتظار الاستلام',
    view_delivered: 'مسلّمة',
    view_missing: 'مفقودة',
    view_in_delivery: 'لدى شركة التوصيل',
    view_printed: 'مطبوعة',
    view_to_print: 'للطباعة',
    view_confirmed: 'للشحن',
    backToAllOrders: 'العودة إلى كل الطلبات',
    moreViews: 'المزيد من العروض',
    view_to_confirm: 'للتأكيد',
    context: 'أكّد الطلبات واشحنها وتابع كل طرد حتى تحصيل المبلغ.',
    column_order: 'الطلب',
    column_items: 'المنتجات',
    column_cod: 'للتحصيل',
    column_carrier: 'شركة التوصيل',
    column_barcode: 'الرمز الشريطي',
    barcodeNone: '—',
    itemCount_zero: 'لا منتجات',
    itemCount_one: 'منتج واحد',
    itemCount_two: 'منتجان',
    itemCount_few: '{{count}} منتجات',
    itemCount_many: '{{count}} منتجًا',
    itemCount_other: '{{count}} منتج',
    filters: 'مرشحات القائمة',
    filter_carrier: 'شركة التوصيل',
    filter_city: 'المدينة',
    filter_date: 'التاريخ',
    filter_remove: 'إزالة مرشح {{name}}',
    carrierUnassigned: 'غير مُسندة',
    searchLabel: 'البحث عن طلب',
    searchPlaceholder: 'رقم الطلب أو رقم التتبع أو الهاتف',
    sortedNewest: 'مرتبة حسب التاريخ، الأحدث أولًا',
    searchScope: 'أفضل 5 طلبات مطابقة',
    noSearchMatch: 'لا يوجد طلب مطابق',
    noSearchMatchHelp: 'تحقق من الرقم أو رقم التتبع أو الهاتف.',
    export: 'تصدير',
    newOrder: 'طلب جديد',
    number: 'رقم الطلب',
    customer: 'الحريف',
    phone: 'الهاتف',
    destination: 'الوجهة',
    total: 'المجموع',
    status: 'الحالة',
    createdAt: 'تاريخ الإنشاء',
    status_PENDING: 'في الانتظار',
    status_CONFIRMED: 'مؤكَّد',
    status_CANCELED: 'ملغى',
    payment_COD_PENDING: 'للتحصيل',
    payment_VOID: 'ملغى',
    status_DISPATCH_REQUESTED: 'قيد الإرسال إلى شركة التوصيل',
    status_DISPATCHED: 'تم الشحن',
    status_IN_TRANSIT: 'في الطريق',
    status_OUT_FOR_DELIVERY: 'قيد التوصيل',
    status_DELIVERED: 'تم التسليم',
    status_DELIVERY_FAILED: 'فشل التسليم',
    status_RETURNING: 'قيد الإرجاع',
    status_RETURNED: 'مُرجع',
    status_RETURN_RECEIVED: 'استُلم المرتجع',
    payment_COD_COLLECTED: 'تم التحصيل',
    payment_SETTLED: 'مُحوَّل',
    payment_DISPUTED: 'محل نزاع',
    dispatch: 'شحن',
    dispatching: 'جارٍ الإرسال…',
    dispatchTitle: 'شحن الطلب {{number}}',
    dispatchMessage: 'اختر شركة التوصيل. يُخصم المخزون المحجوز عند تسجيل الطرد لديها.',
    dispatchRequested: 'أُرسل الطلب {{number}} إلى شركة التوصيل',
    dispatchFailed: 'رُفض آخر إرسال: {{reason}}',
    carrierMessage: 'رسالة شركة التوصيل: «{{message}}»',
    carrierStatus: 'حالة شركة التوصيل',
    carrierStatusNone: '—',
    carrierStatusLine: '{{status}} · حُدِّثت {{when}}',
    noCarrier: 'لم يتم إعداد أي شركة توصيل لمتجرك بعد.',
    configureCarriers: 'إعداد شركات التوصيل',
    carrier: 'شركة التوصيل',
    shipment: 'الشحنة',
    carrierReference: 'رقم وصل التسليم لدى الناقل',
    trackingNumber: 'رقم التتبع',
    trackingPending: 'في انتظار شركة التوصيل',
    labelPrint: 'طباعة الملصق',
    labelPrintFailed: 'تعذّر فتح الطباعة. أعد المحاولة أو نزّل الملصق.',
    labelDownload: 'تنزيل',
    labelPreparing: 'جارٍ التحضير…',
    labelDownloaded: 'تم تنزيل الملصق',
    fillSender: 'إدخال بيانات المرسل',
    view: 'عرض',
    view_all: 'الكل',
    noOrders: 'لا توجد طلبات بعد',
    noOrdersHelp: 'أنشئ طلبك الأول انطلاقًا من حريف.',
    noMatch: 'لا توجد طلبات في هذا العرض',
    noMatchHelp: 'اختر عرضًا آخر أو أنشئ طلبًا.',
    lines: 'المنتجات',
    quantity: 'الكمية',
    unitPrice: 'سعر الوحدة',
    lineTotal: 'مجموع السطر',
    itemsSubtotal: 'مجموع المنتجات',
    shippingFee: 'معلوم التوصيل',
    totalAmount: 'المجموع',
    codAmount: 'المبلغ المحصّل عند التسليم',
    delivery: 'التوصيل',
    address: 'العنوان',
    governorate: 'الولاية',
    delegation: 'المعتمدية',
    postalCode: 'الترقيم البريدي',
    company: 'الشركة',
    depot: 'المخزن',
    exchange: 'استبدال',
    exchangeHelp: 'يسترجع الموزّع منتجًا.',
    note: 'تعليق',
    history: 'السجل',
    historyCreated: 'أُنشئ',
    masked: 'البيانات الشخصية مخفية حسب دورك.',
    confirm: 'تأكيد',
    reopen: 'إرجاع إلى الانتظار',
    cancel: 'إلغاء الطلب',
    confirmed: 'تم تأكيد الطلب {{number}}',
    reopened: 'أُرجع الطلب {{number}} إلى الانتظار',
    canceled: 'أُلغي الطلب {{number}}',
    cancelTitle: 'إلغاء الطلب {{number}}؟',
    cancelMessage: 'يعود المخزون المحجوز متاحًا. لا يمكن استئناف طلب ملغى.',
    cancelAtCarrier: 'سيُلغى الطرد أيضًا لدى {{carrier}}. لا يعود ذلك ممكنًا بعد أن تستلمه شركة التوصيل.',
    cancelReason: 'السبب',
    keepOrder: 'الاحتفاظ بالطلب',
    reason_out_of_stock: 'نفاد المخزون',
    reason_unreachable: 'تعذّر الاتصال بالحريف',
    reason_customer_declined: 'رفض الحريف',
    reason_fraud_suspected: 'اشتباه في احتيال',
    reason_duplicate: 'طلب مكرّر',
    reason_other: 'سبب آخر',
    reason_unconfirmed_expired: 'لم تُؤكَّد في الوقت',
    reason_carrier_canceled: 'أُلغيت لدى شركة التوصيل',
    edit: 'تعديل',
    historyAmended: 'عُدِّلت: {{fields}}',
    historyPayment: 'الدفع: {{status}}',
    field_shipping: 'العنوان',
    field_lines: 'المنتجات',
    field_shippingFee: 'معلوم التوصيل',
    field_note: 'التعليق',
    field_customer: 'الحريف',
    field_isExchange: 'الاستبدال',
    field_subsidiaryId: 'الشركة',
    source: 'مصدر الطلب',
    sourceHelp: 'من أين جاء العميل: يغذّي جدول القنوات في الإحصائيات.',
    source_none: 'غير محدَّد',
    source_facebook: 'صفحة فيسبوك',
    source_instagram: 'إنستغرام',
    source_tiktok: 'تيك توك',
    source_whatsapp: 'واتساب',
    source_phone: 'الهاتف',
    source_other: 'أخرى',
    field_source: 'المصدر',
  },
  newOrder: {
    feeAtDispatch: 'يُضاف معلوم التوصيل عند الإرسال حسب الناقل المختار.',
    context: 'اختر الشركة ثم المنتجات ثم الحريف؛ يُحجز المخزون عند الإنشاء.',
    customerSection: 'الحريف',
    customerSearch: 'الحريف',
    customerPlaceholder: 'اختر حريفًا أو اكتب رقم هاتفه',
    customerByPhoneOnly: 'اكتب رقم الهاتف كاملًا للعثور على الحريف، أو أنشئه.',
    noCustomerFound: 'لا يوجد حريف بهذا الرقم.',
    createCustomer: 'إنشاء حريف',
    createCustomerNamed: 'إنشاء الحريف «{{text}}»',
    changeCustomer: 'تغيير الحريف',
    deliverySection: 'التوصيل',
    selectGovernorate: 'اختر ولاية',
    anyDelegation: 'غير محدّدة',
    itemsSection: 'المنتجات',
    searchProducts: 'ابحث عن منتج أو امسحه ضوئيًا',
    productPlaceholder: 'الاسم أو المرجع أو الرمز الشريطي',
    productHelp: 'زر الإدخال يضيف المنتج الممسوح مباشرة.',
    scanAdded: 'تمت إضافة {{name}}',
    scanOtherCompany: '{{name}} تابع لشركة أخرى.',
    scanOutOfStock: '{{name}} غير متوفر في هذا المخزن',
    scanArchived: 'هذا المنتج مؤرشف ولا يمكن طلبه',
    noProducts: 'لم يُعثر على أي منتج.',
    add: 'إضافة',
    added: 'أُضيف',
    available: 'المتاح: {{quantity}}',
    remove: 'حذف',
    noLines: 'أضف منتجًا واحدًا على الأقل.',
    summarySection: 'الملخّص',
    create: 'إنشاء الطلب',
    creating: 'جارٍ الإنشاء…',
    created: 'تم إنشاء الطلب {{number}}',
    customerRequired: 'اختر حريفًا.',
    addressRequired: 'العنوان إجباري.',
    governorateRequired: 'اختر ولاية.',
    quantityInvalid: 'أدخل عددًا صحيحًا من 1 إلى 10 000.',
    amountInvalid: 'أدخل مبلغًا موجبًا بثلاثة أرقام عشرية على الأكثر.',
    itemsHint: 'ابحث عن المنتج أو امسحه، ثم عدّل الكميات والأسعار.',
    emptyLinesHint: 'تظهر المنتجات المضافة هنا مع كمياتها وأسعارها.',
    customerHint: 'اختر حريفًا موجودًا أو أنشئ حريفًا جديدًا في ثوانٍ.',
    deliveryHint: 'العنوان الذي يُسلَّم للناقل والمخزن الذي يجهّز الطرد.',
    optionsSection: 'خيارات',
    optionsHint: 'قناة البيع والاستبدال وتعليمات الموزّع.',
    sectionComplete: 'مكتمل',
    readinessTitle: 'قبل الإنشاء',
    readyItems: 'منتج واحد على الأقل',
    readyCustomer: 'حريف مختار',
    readyDelivery: 'عنوان وولاية',
    stepDone: 'تمّ',
    stepTodo: 'متبقٍّ',
    unitsCount: 'الوحدات',
    decreaseQuantity: 'إنقاص الكمية',
    increaseQuantity: 'زيادة الكمية',
  },
  errors: {
    DEPENDENCY_UNAVAILABLE: 'خدمة يعتمد عليها المتجر لا تستجيب. حاول مجددًا بعد بضع دقائق.',
    TENANT_SUBSIDIARY_NAME_TAKEN: 'توجد شركة فرعية بهذا الاسم.',
    TEAM_MEMBER_EXISTS: 'هذا الشخص عضو في الفريق بالفعل.',
    TEAM_LAST_ADMIN: 'يجب أن يحتفظ المتجر بمسؤول نشط واحد على الأقل.',
    TEAM_SELF_CHANGE: 'لا يمكنك تعديل صلاحياتك بنفسك. اطلب ذلك من مسؤول آخر.',
    DASHBOARD_VIEW_LIMIT_REACHED:
      'يمكنك الاحتفاظ بـ 10 عروض للوحة القيادة كحد أقصى. احذف عرضًا لحفظ عرض آخر.',
    DASHBOARD_VIEW_NAME_TAKEN: 'لديك بالفعل عرض بهذا الاسم. اختر اسمًا آخر.',
    TEAM_GRANT_NOT_ALLOWED: 'وحده المسؤول يمكنه منح هذه الصلاحية.',
    UNKNOWN: 'حدث خطأ ما. أعد المحاولة بعد لحظات.',
    SHIPPING_CARRIER_AUTH_FAILED:
      'رفضت شركة التوصيل بيانات دخول الحساب. تحقق منها في الإعدادات ثم حاول مجددًا.',
    SHIPPING_CARRIER_NOT_CONFIGURED:
      'شركة التوصيل هذه غير مُعدّة أو موقوفة. تحقق منها في الإعدادات ثم حاول مجددًا.',
    SHIPPING_CANCEL_UNSUPPORTED: 'لا تسمح شركة التوصيل هذه بالإلغاء عبر الإنترنت. اتصل بها لإلغاء الطرد.',
    SHIPPING_CANCEL_REFUSED: 'استلمت شركة التوصيل الطرد ورفضت إلغاءه. عالجه كمرتجع.',
    SHIPPING_UPDATE_REFUSED: 'رفضت شركة التوصيل التعديل: ربما تم استلام الطرد بالفعل. لم يتغيّر شيء.',
    SHIPPING_UPDATE_UNSUPPORTED: 'شركة التوصيل هذه لا تسمح بتعديل طرد تم إرساله. لم يتغيّر شيء.',
    SHIPPING_CARRIER_VALIDATION_FAILED:
      'رفضت شركة التوصيل الطرد. تحقق من عنوان العميل وهاتفه ثم حاول مجددًا.',
    SHIPPING_DISPATCH_UNCERTAIN:
      'ربما أنشأت شركة التوصيل الطرد بالفعل. تحقّق من بوابتها قبل الإرسال مجددًا، وإلا سيُنشأ طرد مكرّر.',
    ORDERS_CANCEL_IN_PROGRESS: 'الإلغاء جارٍ لدى شركة التوصيل، وسيتم تحديث الطلبية تلقائيًا.',
    SHIPPING_CARRIER_UNAVAILABLE: 'شركة التوصيل لا تستجيب. حاول مجددًا بعد بضع دقائق.',
    SHIPPING_HANDOVER_DUPLICATE: 'هذا الطرد سُلّم بالفعل لشركة التوصيل.',
    SHIPPING_HANDOVER_REFUSED: 'لا يمكن استعمال هذا الطرد أو هذا التسليم هنا.',
    SHIPPING_LABEL_NOT_READY: 'الملصق قيد التحضير. حاول مجددًا بعد بضع ثوانٍ.',
    SHIPPING_SENDER_MISSING: 'أدخل بيانات المرسل في الإعدادات لتتمكن من طباعة الملصقات.',
    SHIPPING_UNREACHABLE: 'خدمة الشحن لا تستجيب. حاول مجددًا بعد بضع دقائق.',
    AUTH_ROLE_REQUIRED: 'دورك لا يسمح بهذا الإجراء.',
    CATALOG_CATEGORY_CYCLE: 'لا يمكن أن تكون الفئة أصلًا لنفسها.',
    CATALOG_CATEGORY_NOT_EMPTY: 'هذه الفئة ما زالت تحتوي على فئات فرعية أو منتجات.',
    CATALOG_REFERENCE_TAKEN: 'هذا المرجع مستعمل من طرف منتج آخر.',
    CATALOG_OPTION_TAKEN: 'هذا الاسم مستعمل؛ اختره من القائمة.',
    CATALOG_OPTION_RESERVED: 'المصدر تديره المنصة: اختر محلي أو مستورد مع بلده.',
    CATALOG_VARIANT_IN_USE: 'لهذا المتغيّر حركات مخزون مسجّلة، لذلك لا يمكن حذفه.',
    CATALOG_SLUG_TAKEN: 'هذا الاسم يعطي عنوانًا مستعملًا. اختر اسمًا آخر.',
    CATALOG_TRANSLATION_MISSING: 'ترجمة اللغة الافتراضية إجبارية.',
    CONCURRENCY_CONFLICT: 'قام شخص آخر بتعديل هذا العنصر أثناء تحريرك. أعد التحميل ثم حاول مجددًا.',
    FEATURE_NOT_ENTITLED: 'هذه الميزة غير متوفرة في باقتك.',
    INVENTORY_INITIAL_STOCK_EXISTS: 'لهذا المتغيّر مخزون مسجّل؛ عدّله عبر حركة.',
    INVENTORY_INSUFFICIENT_STOCK: 'المخزون غير كافٍ في هذا المستودع.',
    INVENTORY_LOCATION_ARCHIVED: 'هذا المستودع مؤرشف ولا يقبل حركات جديدة.',
    INVENTORY_LOCATION_NOT_EMPTY: 'ما زال هذا المستودع يحتوي على مخزون: انقل وحداته أو أخرجها قبل أرشفته.',
    INVENTORY_DEFAULT_LOCATION_REQUIRED:
      'يحتفظ المتجر دائمًا بمستودع افتراضي: اختر مستودعًا آخر قبل تعديل هذا.',
    MEDIA_TYPE_NOT_ALLOWED: 'هذا النوع من الملفات غير مقبول هنا.',
    MEDIA_TOO_LARGE: 'حجم هذه الصورة أكبر من المسموح.',
    MEDIA_IMAGE_TOO_LARGE: 'عدد بكسلات هذه الصورة كبير جدًا: صغّرها قبل الإرسال.',
    MEDIA_UPLOAD_INCOMPLETE: 'لم يكتمل الإرسال. أعد المحاولة.',
    MEDIA_CHECKSUM_MISMATCH: 'تغيّر الملف أثناء الإرسال. أعد المحاولة.',
    MEDIA_MALWARE_DETECTED: 'حظر الفحص الأمني هذا الملف.',
    MEDIA_PROCESSING_FAILED: 'تعذّرت معالجة الصورة. أعد المحاولة.',
    MEDIA_UPLOAD_EXPIRED: 'انتهت صلاحية الإرسال. أضف الصورة من جديد.',
    MEDIA_NOT_READY: 'لا تزال إحدى الصور قيد المعالجة. انتظر قليلًا ثم احفظ.',
    RATE_LIMITED: 'طلبات كثيرة جدًا. انتظر بضع ثوانٍ.',
    RESOURCE_CONFLICT: 'هذا العنصر موجود بالفعل.',
    RESOURCE_NOT_FOUND: 'تعذر العثور على هذا العنصر.',
    STATE_TRANSITION_INVALID: 'تغيير الحالة هذا غير مسموح به.',
    VALIDATION_FAILED: 'بعض الحقول غير صالحة. صححها ثم أعد المحاولة.',
    CRYPTO_INTEGRITY_FAILED: 'تعذّرت قراءة هذه البطاقة. اتصل بالدعم مع ذكر وقت الخطأ.',
    CRYPTO_UNAVAILABLE: 'البيانات الشخصية غير متاحة مؤقتًا. أعد المحاولة بعد لحظات.',
    ORDERS_CUSTOMER_PHONE_TAKEN: 'هذا الرقم مستعمل من طرف حريف آخر.',
    IDEMPOTENCY_KEY_REUSED: 'تغيّر هذا الطلب منذ إرساله أول مرة. أعد تحميل الصفحة ثم حاول مجددًا.',
    ORDERS_NOT_EDITABLE: 'سُلِّمت هذه الطلبية لشركة التوصيل أو أُلغيت؛ لم يعد بالإمكان تعديلها.',
    ORDERS_EXPORT_TOO_LARGE:
      'عدد الطلبات كبير جدًا لملف واحد. اختر عرضًا أو أضف مرشحًا (التاريخ، شركة التوصيل، المدينة) ثم أعد المحاولة.',
    ORDERS_RETURN_NOT_EXPECTED: 'هذا الطرد غير منتظر كمرتجع. تحقق من حالته في الطلبيات.',
    ORDERS_LINE_INVALID: 'أحد المنتجات لا يمكن بيعه (غير معروف أو مؤرشف أو مكرّر). احذفه ثم حاول مجددًا.',
  },
  statistics: {
    title: 'الإحصائيات',
    context: 'افهم أين تربح وأين تخسر، خطوة بخطوة.',
    tab_delivery: 'التوصيل',
    tab_confirmation: 'التأكيد',
    tab_products: 'المنتجات',
    tab_orders: 'الطلبات',
    tab_marketing: 'التسويق',
    scope_delivery: 'الطرود المستلمة من {{from}} إلى {{to}}.',
    scope_confirmation: 'الطلبات الواردة من {{from}} إلى {{to}}، حسب معالجة الفريق لها.',
    scope_products: 'وحدات الطلبات الواردة من {{from}} إلى {{to}}.',
    scope_orders: 'الطلبات الواردة من {{from}} إلى {{to}}.',
    scope_marketing: 'الطلبات الواردة من {{from}} إلى {{to}}، حسب المصدر.',
    carrierFilter: 'شركة التوصيل',
    allCarriers: 'كل شركات التوصيل',
    value: 'القيمة',
    margin: 'الربح',
    parcel_depot: 'في مستودع شركة التوصيل',
    parcel_transit: 'في الطريق',
    parcel_delivered: 'مُسلَّمة',
    parcel_failed: 'تعذّر التسليم',
    parcel_returned: 'مرتجعة',
    delayTitle: 'مدة التوصيل',
    delayHelp: 'متوسط المدة من الاستلام إلى التسليم',
    delayBand_1: 'في اليوم التالي',
    delayBand_2: 'يومان',
    delayBand_3: '3 أيام',
    delayBand_4: '4 أيام فأكثر',
    performanceTitle: 'أداء التوصيل',
    performanceHelp: 'على {{parcels}} طردًا بلغ نهاية مساره',
    carriersTitle: 'مقارنة شركات التوصيل',
    carrier: 'شركة التوصيل',
    parcels: 'الطرود',
    deliveryRate: 'نسبة التسليم',
    averageDelay: 'متوسط المدة',
    owed: 'للتحصيل',
    noParcels: 'لم يُستلم أي طرد في هذه الفترة',
    days: '{{value}} يوم',
    minutes: '{{minutes}} د',
    hoursMinutes: '{{hours}} س {{minutes}} د',
    mapTitle: 'نسبة التسليم حسب الولاية',
    mapLow: 'أقل من 65 %',
    mapHigh: '87 % فأكثر',
    mapLabelAll: 'خريطة تونس حسب الولاية',
    mapLabel: '{{name}}، {{rate}}',
    mapNoParcels: '{{name}}، لا طرود',
    mapHint: 'مرّر المؤشر على ولاية أو تنقّل إليها لرؤية أرقامها.',
    mapRank: 'المرتبة {{rank}} من {{total}} ولاية',
    mapSearch: 'البحث عن ولاية',
    bestCarrier: 'أفضل شركة توصيل',
    confirmation_received: 'الطلبات الواردة',
    confirmation_handled: 'المعالَجة',
    confirmation_confirmed: 'المؤكَّدة',
    confirmation_rejected: 'المرفوضة',
    confirmation_pending: 'قيد الانتظار',
    confirmation_delivered: 'سُلِّمت لاحقًا',
    confirmation_returned: 'أُرجعت لاحقًا',
    confirmationRatesTitle: 'نسبة التأكيد',
    netConfirmation: 'الصافية (الطلبات المعالَجة)',
    globalConfirmation: 'الإجمالية (الطلبات الواردة)',
    responsivenessTitle: 'سرعة استجابة الفريق',
    confirmationDelayHelp: 'متوسط المدة بين الورود والتأكيد',
    agentsTitle: 'نسبة التأكيد حسب الموظف',
    agentsHelp: 'تسليم الطلبات المؤكَّدة يقيس جودة التأكيد.',
    agent: 'الموظف',
    formerMember: 'عضو سابق',
    handled: 'المعالَجة',
    confirmationRate: 'التأكيد',
    deliveredAfter: 'سُلِّمت لاحقًا',
    confirmationDelay: 'المدة',
    noDecisions: 'لم تُعالَج أي طلبات في هذه الفترة',
    reasonsTitle: 'أسباب الرفض',
    noRejection: 'لم يُرفض أي طلب في هذه الفترة.',
    units_all: 'الوحدات المطلوبة',
    units_pending: 'قيد الانتظار',
    units_confirmed: 'المؤكَّدة',
    units_rejected: 'المرفوضة',
    units_depot: 'في المستودع',
    units_transit: 'في الطريق',
    units_delivered: 'المُسلَّمة',
    units_returned: 'المرتجعة',
    orders_all: 'الطلبات الواردة',
    orders_pending: 'قيد الانتظار',
    orders_confirmed: 'المؤكَّدة',
    orders_rejected: 'المرفوضة',
    orders_depot: 'في المستودع',
    orders_transit: 'في الطريق',
    orders_delivered: 'المُسلَّمة',
    orders_returned: 'المرتجعة',
    productsTitle: 'الربحية حسب المنتج',
    productsHelp: 'مرتّبة حسب الربح المُسلَّم.',
    purchaseTotal: 'إجمالي الشراء',
    groupBy: 'التجميع حسب',
    byVariant: 'المتغيّر',
    optionTitle: 'الربحية حسب {{option}}',
    optionHelp: 'مرتبة حسب الربح المُسلَّم، لكل المتغيّرات معًا.',
    noOptionValue: 'بدون قيمة',
    product: 'المنتج',
    unitsDelivered: 'الوحدات المُسلَّمة',
    revenue: 'رقم المعاملات',
    unitsReturned: 'المرتجعات',
    noProducts: 'لم تُطلب أي وحدة في هذه الفترة',
    campaignsLater:
      'تفاصيل الحملات والإعلانات تأتي مع المتجر الإلكتروني. المصدر المختار عند إنشاء الطلب يغذّي هذا الجدول من الآن.',
    channelsTitle: 'الأداء حسب القناة',
    channelsHelp: 'المصدر المسجَّل على الطلب.',
    channel: 'القناة',
    orders: 'الطلبات',
    noOrders: 'لا توجد طلبات في هذه الفترة',
  },
  calculator: {
    title: 'حاسبة الربحية',
    context: 'جرّب منتجًا قبل شراء الإعلانات. تتحدّث النتائج أثناء الكتابة.',
    reset: 'إعادة الضبط',
    useRealRates: 'استخدام نسبي الفعلية',
    group_product: 'منتجك',
    group_productHelp: 'ابدأ من منتج في الكتالوج أو أدخل الأرقام بحرية.',
    group_advertising: 'الإعلانات',
    group_advertisingHelp: 'ما تدفعه للحصول على العملاء المحتملين.',
    group_delivery: 'التوصيل',
    group_deliveryHelp: 'أسعار شركة التوصيل.',
    group_rates: 'نسبك',
    group_ratesHelp: 'أدخل نسبك أو استخدم نسب آخر 30 يومًا.',
    field_cost: 'تكلفة الشراء',
    field_price: 'سعر البيع',
    field_priceHelp: 'شامل التوصيل: المبلغ المحصَّل.',
    field_leadCost: 'تكلفة العميل المحتمل',
    field_leads: 'العملاء المحتملون',
    field_deliveryFee: 'لكل طرد مُسلَّم',
    field_returnFee: 'لكل طرد مرتجع',
    field_preparationFee: 'التجهيز',
    field_preparationFeeHelp: 'لكل طلب مؤكَّد.',
    field_confirmationRate: 'نسبة التأكيد',
    field_deliveryRate: 'نسبة التسليم',
    units: 'وحدة',
    issue_invalid: 'أدخل رقمًا موجبًا، مثل 3,5.',
    issue_aboveHundred: 'لا تتجاوز النسبة 100 %.',
    productSearch: 'البدء من منتج',
    productSearchButton: 'بحث',
    productPick: '{{name}} · {{sku}} · {{price}}',
    productNone: 'لا يوجد منتج نشط مطابق.',
    resultTitle: 'النتيجة المقدَّرة',
    profit: 'الربح الصافي المقدَّر',
    loss: 'الخسارة المقدَّرة',
    perDelivered: '{{amount}} لكل طرد مُسلَّم',
    margin: 'الهامش {{value}}',
    incomplete: 'النتيجة بانتظار أرقامك',
    incompleteHelp: 'صحّح الحقول المشار إليها لرؤية النتيجة.',
    funnelTitle: 'من العميل المحتمل إلى التحصيل',
    funnel_leads: 'العملاء المحتملون',
    funnel_confirmed: 'المؤكَّدة',
    funnel_delivered: 'المُسلَّمة',
    funnel_returned: 'المرتجعة',
    splitTitle: 'أين يذهب رقم معاملاتك · {{revenue}}',
    split_productCost: 'تكلفة المنتج',
    split_delivery: 'التوصيل',
    split_returns: 'المرتجعات',
    split_preparation: 'التجهيز',
    split_advertising: 'الإعلانات',
    split_profit: 'الربح',
    advertisingPerDelivered: 'تكلفة الإعلان لكل طرد مُسلَّم',
    breakEven: 'أقصى تكلفة للعميل المحتمل',
    tipGain: 'إذا ارتفعت نسبة التسليم {{points}} نقاط، يزيد ربحك بمقدار {{gain}}.',
    tipBreakEven: 'فوق {{amount}} للعميل المحتمل، يصبح هذا المنتج خاسرًا.',
    realRatesApplied: 'نسبك خلال آخر 30 يومًا: التأكيد {{confirmation}} %، التسليم {{delivery}} %.',
    realRatesMissing: 'لا توجد طلبات كافية خلال 30 يومًا لإحدى النسب؛ تم الإبقاء على القيمة المُدخلة.',
  },
  setup: {
    title: 'إعداد المتجر',
    stepsLabel: 'خطوات الإعداد',
    exit: 'إكمال لاحقًا',
    back: 'رجوع',
    skip: 'تخطي هذه الخطوة',
    start: 'ابدأ',
    continue: 'متابعة',
    finish: 'ابدأ البيع',
    saving: 'جارٍ الحفظ…',
    saved: 'تم الحفظ تلقائيًا',
    finished: 'تم إعداد متجرك.',
    step_welcome: 'مرحبًا',
    step_welcomeHelp: 'نظرة سريعة على المسار',
    step_store: 'متجرك',
    step_storeHelp: 'الاسم واللغة والمنطقة الزمنية',
    step_storeCard: 'الاسم واللغة والبلد والمنطقة الزمنية.',
    step_brand: 'علامتك',
    step_brandHelp: 'الشعار والألوان',
    step_brandCard: 'الشعار والألوان على ملصقاتك.',
    step_delivery: 'التوصيل',
    step_deliveryHelp: 'شركة التوصيل والمرسل',
    step_deliveryCard: 'شركة التوصيل وعنوان الشحن.',
    step_orders: 'الطلبات',
    step_ordersHelp: 'مهلة التأكيد',
    step_ordersCard: 'مهلة التأكيد بالهاتف.',
    welcomeTitle: 'هل أنت مستعد لإطلاق نشاطك؟',
    welcomeLead: 'خمس خطوات قصيرة. يُحفظ كل شيء أولًا بأول، ويمكنك المتابعة لاحقًا.',
    video: 'فيديو الترحيب',
    storeTitle: 'المعلومات الأساسية',
    storeLead: 'تُستخدم في المبالغ والتواريخ والرسائل المرسلة إلى عملائك.',
    storeName: 'اسم المتجر',
    storeNameHelp: 'يظهر على الملصقات ووصولات التسليم.',
    storeNameInvalid: 'أدخل اسمًا من 1 إلى 200 حرف.',
    language: 'اللغة الافتراضية',
    languageHelp: 'يمكن لكل عضو في الفريق اختيار لغته من ملفه الشخصي.',
    country: 'بلد النشاط',
    countryValue: '{{country}} · {{currency}}',
    countryHelp: 'يحدد البلد العملة؛ تواصل مع الدعم لتغييره.',
    timezone: 'المنطقة الزمنية',
    timezoneHelp: 'تُستخدم لملخص الصباح وطلبات اليوم.',
    brandTitle: 'هويتك البصرية',
    brandLead: 'يظهر شعارك وألوانك على ملصقات الطرود ووصولات التسليم.',
    logo: 'الشعار',
    logoDrop: 'اسحب شعارك هنا أو اختر ملفًا',
    logoHelp: 'PNG أو JPEG أو WebP، بحد أقصى 2 ميغابايت.',
    logoRemove: 'إزالة الشعار',
    logoUploading: 'جارٍ تجهيز الشعار…',
    logoRefused: '«{{name}}» ليست صورة PNG أو JPEG أو WebP.',
    logoBusy: 'انتظر حتى يجهز الشعار قبل المتابعة.',
    logoAlt: 'شعار المتجر',
    colors: 'الألوان',
    color_primary: 'الرئيسي',
    color_secondary: 'الثانوي',
    color_accent: 'المميِّز',
    colorReadable: 'يبقى النص الأبيض مقروءًا.',
    colorLowContrast: 'يصعب قراءة النص الأبيض على هذا اللون.',
    colorInvalid: 'الصيغة المطلوبة: #RRGGBB.',
    colorSample: 'أب',
    previewTitle: 'معاينة الملصق',
    previewRecipient: 'المستلم',
    previewAmount: 'المبلغ المطلوب تحصيله',
    previewSample: 'أميرة ت. · سوسة',
    deliveryTitle: 'كيف توصل طلباتك؟',
    deliveryLead: 'اربط شركة توصيل واحدة على الأقل وأدخل المرسل المطبوع على كل طرد.',
    senderTitle: 'مرسل الملصقات',
    deliveryReadOnly: 'لا يمكن تعديل هذه الخطوة إلا لمن يدير شركات التوصيل.',
    ordersTitle: 'طلباتك',
    ordersLead: 'كم من الوقت يمكن أن ينتظر الطلب التأكيد بالهاتف قبل إلغائه؟',
    window: 'مهلة التأكيد',
    windowHours: '{{count}} ساعة',
    windowHelp_24: 'للمنتجات كثيرة الطلب.',
    windowHelp_48: 'موصى به لمعظم المتاجر.',
    windowHelp_72: 'للعملاء الذين يصعب الوصول إليهم.',
    windowHelp_current: 'إعدادك الحالي.',
    summaryTitle: 'الملخص',
    summaryBranded: 'تم حفظ الشعار والألوان',
    summaryUnbranded: 'لم تُحدَّد بعد',
    summaryNoCarrier: 'لا يوجد بعد',
    trackTitle: 'إعداد متجرك',
    trackSummary_zero: 'لم تبقَ أي خطوة قبل الشحن.',
    trackSummary_one: 'بقيت خطوة واحدة قبل أن تتمكن من الشحن.',
    trackSummary_two: 'بقيت خطوتان قبل أن تتمكن من الشحن.',
    trackSummary_few: 'بقيت {{count}} خطوات قبل أن تتمكن من الشحن.',
    trackSummary_many: 'بقيت {{count}} خطوة قبل أن تتمكن من الشحن.',
    trackSummary_other: 'بقيت {{count}} خطوة قبل أن تتمكن من الشحن.',
    trackSummaryDone: 'كل شيء جاهز. يمكنك مراجعة أي خطوة.',
    trackProgress: '{{done}} من {{total}}',
    trackToggle: 'إظهار الخطوات أو إخفاؤها',
    trackResume: 'متابعة الإعداد',
    trackReview: 'مراجعة الإعداد',
  },
  settings: {
    context: 'كل ما تحتاجه للشحن: شركات التوصيل والملصقات وقواعد الطلبات.',
  },

  editOrder: {
    title: 'تعديل الطلبية',
    titleOf: 'تعديل {{number}}',
    context: 'العنوان والمنتجات والمعلوم والملاحظة؛ المخزون المحجوز يتبع المنتجات الجديدة.',
    save: 'حفظ',
    saving: 'جارٍ الحفظ…',
    saved: 'تم تعديل الطلبية {{number}}',
    discard: 'إلغاء التعديلات',
    back: 'العودة إلى الطلبية',
    notEditable: 'لم يعد بالإمكان تعديل هذه الطلبية',
    notEditableHelp:
      'يمكن تعديل الطلبيات المعلّقة أو المؤكَّدة، وكذلك عنوان طرد لم تستلمه بعد شركة توصيل تقبل التعديلات.',
    atCarrierHelp:
      'الطرد لدى {{carrier}} ولم يُستلم بعد: يمكن تغيير عنوان التوصيل والملاحظة فقط. يُرسل التعديل إلى {{carrier}}؛ وإذا رُفض لا يتغيّر شيء.',
    lockedItems: 'المنتجات (مقفلة بعد الإرسال)',
    sendToCarrier: 'إرسال إلى {{carrier}}',
    savedAtCarrier: 'تم تعديل الطلبية {{number}} لدى {{carrier}}',
    masked: 'لا يمكنك رؤية بيانات الحريف',
    maskedHelp: 'اطلب صلاحية الوصول إلى بيانات الحرفاء لتعديل العنوان.',
    archivedDepot: 'مستودع مؤرشف',
  },
  orderSettings: {
    hoursLong: '{{count}} ساعة',
    rule: 'الطلب الذي لا يتم تأكيده خلال هذه المدة يُلغى تلقائيًا وتعود منتجاته إلى المخزون.',
    title: 'الإلغاء التلقائي',
    context: 'يحرر المخزون المحجوز بطلبات لا يؤكدها الزبون أبدًا.',
    window: 'مهلة التأكيد',
    windowHelp: 'بالساعات، من 1 إلى 720 (30 يومًا).',
    windowInvalid: 'أدخل عددًا صحيحًا من الساعات بين {{min}} و{{max}}.',
    edit: 'تغيير المدة',
    saved: 'تم حفظ مهلة التأكيد',
  },
  expenses: {
    context: 'مصاريف المتجر حسب اليوم والفرع. تُنقص من النتيجة الصافية في النظرة العامة.',
    newTitle: 'مصروف جديد',
    editTitle: 'تعديل المصروف',
    name: 'البيان',
    amount: 'المبلغ',
    spentOn: 'التاريخ',
    subsidiary: 'الفرع',
    wholeShop: 'كامل المتجر',
    note: 'ملاحظة',
    nameRequired: 'أدخل بيانًا.',
    amountInvalid: 'أدخل مبلغًا صحيحًا.',
    dayRequired: 'اختر تاريخ المصروف.',
    archive: 'أرشفة',
    restore: 'استعادة',
    view: 'عرض',
    view_active: 'النشطة',
    view_archived: 'المؤرشفة',
    none: 'لا توجد مصاريف بعد',
    noneHelp: 'سجّل الكراء أو التغليف أو الإشهار لمتابعة النتيجة الصافية.',
    noneArchived: 'لا توجد مصاريف مؤرشفة',
    saved: 'تم حفظ المصروف «{{name}}»',
    archived: 'تمت أرشفة المصروف «{{name}}»',
    restored: 'تمت استعادة المصروف «{{name}}»',
  },
  finance: {
    section_expenses: 'المصاريف',
    kpiExpenses: 'مصاريف الفترة',
    kpiNet: 'النتيجة الصافية',
    sections: 'أقسام المالية',
    section_overview: 'نظرة عامة',
    section_remittances: 'كشوف شركات التوصيل',
    section_disputes: 'النزاعات',
    context: 'ما حصّلته كل شركة توصيل وما حوّلته وما لا تزال مدينة به للمتجر.',
    carrier: 'شركة التوصيل',
    delivered: 'مُسلَّمة',
    remitted: 'مُحوَّلة',
    carrierFees: 'معاليم التوصيل',
    returnFees: 'معاليم الإرجاع',
    awaiting: 'للتحويل',
    disputes: 'النزاعات',
    kpiAwaiting: 'محصَّل ولم يُحوَّل بعد',
    kpiRemitted: 'المحوَّل خلال الفترة',
    kpiFees: 'معاليم شركات التوصيل خلال الفترة',
    kpiDisputes: 'النزاعات المفتوحة',
    noFigures: 'لا توجد أرقام لهذه الفترة',
    noFiguresHelp: 'ستظهر هنا الطرود المسلَّمة والكشوف المستوردة.',
  },
  disputes: {
    context: 'الطرود التي يختلف مبلغها المحوَّل عن المبلغ الواجب تحصيله.',
    view: 'عرض',
    view_disputed: 'مفتوحة',
    view_resolved: 'محلولة',
    trackingNumber: 'رقم التتبع',
    carrier: 'شركة التوصيل',
    expected: 'الواجب تحصيله',
    collected: 'المحوَّل',
    difference: 'الفارق',
    since: 'منذ',
    status: 'الحالة',
    status_settled: 'مُسوّى',
    status_disputed: 'محل نزاع',
    status_resolved: 'محلول',
    none: 'لا توجد نزاعات مفتوحة',
    noneHelp: 'ستظهر هنا فوارق المبالغ المكتشفة عند استيراد كشف.',
    noneResolved: 'لا توجد نزاعات محلولة',
    resolveTitle: 'حل النزاع {{trackingNumber}}',
    resolve: 'حل',
    expectedWas: 'المبلغ الواجب تحصيله: {{amount}}',
    collectedAmount: 'المبلغ المحوَّل في النهاية',
    collectedHelp: 'اتركه فارغًا إذا ظل المبلغ غير معروف.',
    amountInvalid: 'أدخل مبلغًا صحيحًا.',
    note: 'ملاحظة الحل',
    noteHelp: 'اشرح ما تم الاتفاق عليه مع شركة التوصيل.',
    noteRequired: 'أضف ملاحظة الحل.',
    resolved: 'تم حل النزاع {{trackingNumber}}',
  },
  remittances: {
    context: 'استورد كشوف التحويل من شركات التوصيل: كل طرد يُسوّى أو يُعلَّق في نزاع أو يُشار إليه.',
    importTitle: 'استيراد كشف',
    import: 'استيراد',
    carrier: 'شركة التوصيل',
    noCarrier: 'أعدّ حساب شركة توصيل أولًا.',
    sourcePaste: 'لصق أو مسح',
    sourceCsv: 'ملف CSV',
    codes: 'رموز الطرود',
    codesHelp: 'طرد في كل سطر: امسح الرموز الشريطية أو الصق أعمدة الرمز والمبلغ والمعلوم.',
    drop: 'اختر ملف CSV أو اسحبه هنا',
    dropHelp: 'احفظ كشف شركة التوصيل بصيغة CSV. يُقرأ الملف في متصفحك.',
    fileTooLarge: 'يتجاوز هذا الملف 2 ميغابايت. قسّم الكشف إلى عدة ملفات.',
    nothingRead: 'لم يُقرأ أي رمز طرد. الصق رموزًا أو اختر ملفًا.',
    preview: 'الطرود المقروءة: {{count}}',
    invalidRows: 'أسطر تم تجاهلها لتعذّر قراءتها: {{rows}}',
    importedAt: 'تاريخ الاستيراد',
    source: 'المصدر',
    source_paste: 'ملصق أو ممسوح',
    source_csv: 'ملف CSV',
    lines: 'الأسطر',
    settled: 'مُسوّاة',
    disputed: 'محل نزاع',
    attention: 'للتحقق',
    none: 'لم يُستورد أي كشف بعد',
    noneHelp: 'استورد كشف تحويل من شركة توصيل لتسوية الطرود المسلَّمة.',
    detailTitle: 'كشف مستورد',
    detailTitleOf: 'كشف {{date}}',
    detailContext: 'نتيجة كل سطر من الكشف. تُعالج النزاعات من قسم المالية.',
    back: 'العودة إلى الكشوف',
    trackingNumber: 'رقم التتبع',
    amount: 'المبلغ',
    fee: 'المعلوم',
    outcome: 'النتيجة',
    kpi_lineCount: 'الأسطر',
    kpi_settledCount: 'مُسوّاة',
    kpi_disputedCount: 'محل نزاع',
    kpi_attentionCount: 'للتحقق',
    view: 'عرض',
    view_all: 'الكل',
    view_attention: 'للتحقق',
    view_disputed: 'النزاعات',
    view_settled: 'مُسوّاة',
    noLines: 'لا توجد أسطر في هذا العرض',
    outcome_settled: 'مُسوّى',
    outcome_return_fee: 'معلوم الإرجاع',
    outcome_disputed: 'مبلغ مختلف',
    outcome_duplicate: 'مُسوّى سابقًا',
    outcome_not_delivered: 'لم يُسلَّم بعد',
    outcome_unknown: 'طرد غير معروف',
    outcome_wrong_carrier: 'شركة توصيل أخرى',
  },
  parcels: {
    returnedTitle: 'الطرود المُرجَعة',
    returnedContext_zero: 'لا طرود قيد الإرجاع أو مُرجَعة أو مستلمة',
    returnedContext_one: 'طرد واحد قيد الإرجاع أو مُرجَع أو مستلم',
    returnedContext_two: 'طردان قيد الإرجاع أو مُرجَعان أو مستلمان',
    returnedContext_few: '{{count}} طرود قيد الإرجاع أو مُرجَعة أو مستلمة',
    returnedContext_many: '{{count}} طردًا قيد الإرجاع أو مُرجَعًا أو مستلمًا',
    returnedContext_other: '{{count}} طرد قيد الإرجاع أو مُرجَع أو مستلم',
    missingTitle: 'الطرود المفقودة',
    missingContext_zero: 'لا طرود لدى شركة التوصيل ولم يُسلَّم بعد انقضاء المهلة المتوقعة',
    missingContext_one: 'طرد واحد لدى شركة التوصيل ولم يُسلَّم بعد انقضاء المهلة المتوقعة',
    missingContext_two: 'طردان لدى شركة التوصيل ولم يُسلَّم بعد انقضاء المهلة المتوقعة',
    missingContext_few: '{{count}} طرود لدى شركة التوصيل ولم يُسلَّم بعد انقضاء المهلة المتوقعة',
    missingContext_many: '{{count}} طردًا لدى شركة التوصيل ولم يُسلَّم بعد انقضاء المهلة المتوقعة',
    missingContext_other: '{{count}} طرد لدى شركة التوصيل ولم يُسلَّم بعد انقضاء المهلة المتوقعة',
    searchLabel: 'البحث عن طرد',
    searchPlaceholder: 'الرمز الشريطي أو رقم الطلب أو الهاتف',
    returnedSince: 'مُرجَع منذ',
    createdSince: 'أُنشئ',
    receive: 'استلام المرتجعات',
    returnedEmpty: 'لا يوجد طرد مُرجَع',
    returnedEmptyHelp: 'تظهر هنا الطرود التي تعيدها شركة التوصيل.',
    missingEmpty: 'لا يوجد طرد مفقود',
    missingEmptyHelp: 'يظهر الطرد هنا عندما يبقى لدى شركة التوصيل دون تسليم بعد انقضاء المهلة المتوقعة.',
    noMatch: 'لا يوجد طرد مطابق',
    noMatchHelp: 'غيّر البحث أو امسح عوامل التصفية.',
  },
  returns: {
    searchLabel: 'بحث في المرتجعات',
    searchPlaceholder: 'الرمز الشريطي أو رقم الطلبية أو الهاتف',
    reported: 'أُبلغ عنه',
    toReceiveNoMatch: 'لا يوجد طرد مطابق',
    context:
      'امسح الطرود التي عادت إلى المستودع (الرمز الشريطي أو رقم الطلبية أو هاتف الحريف) ثم استلمها دفعة واحدة: المنتجات السليمة تعود إلى المخزون والمتضررة تُشطب منه.',
    suggestionsTitle: 'الطرود المطابقة',
    noSuggestion: 'لا يوجد طرد مطابق',
    suggestionsCount_one: 'طرد واحد مطابق',
    suggestionsCount_two: 'طردان مطابقان',
    suggestionsCount_few: '{{count}} طرود مطابقة',
    suggestionsCount_many: '{{count}} طردًا مطابقًا',
    suggestionsCount_other: '{{count}} طرد مطابق',
    searching: 'جارٍ البحث…',
    inBasket: 'موجود في القائمة',
    notReceivableShort: 'غير قابل للاستلام بعد',
    scanLabel: 'رمز الطرد',
    scanHelp: 'الرمز الشريطي أو رقم التتبع أو رقم الطلبية أو هاتف الحريف.',
    find: 'بحث',
    added: 'أُضيف الطرد {{number}}.',
    notFound: '{{code}}: لم يُعثر على أي طرد.',
    alreadyScanned: 'الطرد {{number}} موجود في القائمة.',
    notReceivable: 'الطرد {{number}} لا يمكن استلامه (الحالة: {{status}}).',
    chooseTitle: 'طرود مطابقة',
    chooseHelp: 'عدة طرود مطابقة ({{count}}): اختر الطرد الذي عاد.',
    basketTitle: 'الطرود الممسوحة ({{count}})',
    basketEmpty: 'امسح طردًا أو أضفه من قائمة « في انتظار الاستلام ».',
    parcel: 'الطرد {{number}}',
    articles: 'المنتجات: {{count}}',
    notAnnounced: 'لم تُبلغ عنه {{carrier}} كمرتجع بعد',
    markDamaged: 'متضرر؟',
    damagedCount: 'متضرر: {{count}}',
    remove: 'إزالة الطرد {{number}}',
    quantity: 'الكمية: {{count}}',
    damaged: 'متضرر',
    damagedInvalid: 'أدخل عددًا صحيحًا بين 0 و{{max}}.',
    restock: 'يعود إلى المخزون: {{count}}',
    receiveAll: 'استلام الطرود ({{count}})',
    receiving: 'جارٍ الاستلام…',
    receivedCount: 'المستلمة: {{count}} · المرفوضة: {{refused}}',
    confirmTitle: 'طرود لم يُبلغ عنها كمرتجعات بعد: {{count}}',
    confirmMessage:
      '{{numbers}}: لم تُبلغ عنها شركة التوصيل كمرتجعات بعد. أكّد أنها عادت فعلًا إلى المستودع.',
    confirmCancel: 'التحقق أولًا',
    toReceiveTitle: 'في انتظار الاستلام ({{count}})',
    toReceiveHelp: 'طرود أبلغت عنها شركة التوصيل كمرتجعات ولم تُستلم بعد.',
    toReceiveEmpty: 'لا يوجد طرد في انتظار الاستلام.',
    addAll: 'إضافة الكل ({{count}})',
    add: 'إضافة الطرد {{number}}',
    addShort: 'إضافة',
    received: 'استُلمت {{number}} · إلى المخزون: {{restocked}} · متضرر: {{damaged}}',
    sessionTitle: 'المستلمة في هذه الجلسة',
    sessionEmpty: 'لم يُستلم أي طرد بعد.',
  },
  handover: {
    searchLabel: 'بحث في عمليات التسليم',
    searchPlaceholder: 'رقم تتبع الطرد أو رقم الطلبية',
    noMatch: 'لا توجد عملية تسليم مطابقة',
    noMatchHelp: 'غيّر البحث أو امسح عوامل التصفية.',
    context: 'امسح الطرود المسلّمة للموزّع ثم اطبع وصل الخروج لتوقيعه.',
    startTitle: 'تسليم جديد',
    noCarrier: 'لا توجد شركة توصيل مُعدّة. أعدّ واحدة في الإعدادات.',
    carrier: 'شركة التوصيل',
    start: 'بدء التسليم',
    history: 'التسليمات الأخيرة',
    openedAt: 'فُتح في',
    status: 'الحالة',
    status_open: 'جارٍ',
    status_closed: 'مُغلق',
    count: 'الطرود',
    total: 'المبلغ المحصّل',
    voucher: 'وصل الخروج',
    downloadVoucher: 'تنزيل وصل الخروج',
    voucherDownloaded: 'تم تنزيل وصل الخروج',
    none: 'لا يوجد تسليم بعد',
    noneHelp: 'ابدأ تسليمًا لمسح الطرود المسلّمة للموزّع.',
    scanLabel: 'رقم التتبع أو الطلبية',
    scanHelp: 'امسح الملصق أو اكتب رقمًا: تتم تصفية قائمة الطرود الجاهزة أثناء الكتابة، و Entrée يضيف الطرد.',
    add: 'إضافة',
    addParcel: 'إضافة الطرد {{trackingNumber}}',
    readyTitle: 'طرود جاهزة للتسليم',
    readyNone: 'لا يوجد طرد في انتظار هذا الناقل.',
    readyNoMatch: 'لا يوجد طرد جاهز يطابق «{{search}}».',
    accepted: 'سُلّم {{trackingNumber}} لشركة التوصيل',
    back: 'كل التسليمات',
    countValue: '{{count}} طرد',
    trackingNumber: 'رقم التتبع',
    order: 'الطلب',
    recipient: 'المستلم',
    phone: 'الهاتف',
    place: 'الوجهة',
    amount: 'المبلغ',
    empty: 'لم يُمسح أي طرد',
    emptyHelp: 'امسح الطرد الأول للبدء.',
    close: 'إغلاق وطباعة الوصل',
    closeTitle: 'إغلاق التسليم؟',
    closeMessage: 'سيُدرج {{count}} طرد في وصل خروج {{carrier}}. لن يمكن تعديل التسليم بعد ذلك.',
    closeConfirm: 'إغلاق التسليم',
    refused_closed: 'هذا التسليم مُغلق.',
    refused_wrong_carrier: 'هذا الطرد تابع لشركة توصيل أخرى.',
    refused_not_ready: 'هذا الطرد لا ينتظر الاستلام (استُلم أو أُلغي أو لم يُسجّل بعد).',
    refused_empty: 'امسح طردًا واحدًا على الأقل قبل الإغلاق.',
    refused_currency: 'هذا الطرد ليس بعملة التسليم.',
  },
  sender: {
    taxIdLine: 'المعرف الجبائي: {{value}}',
    taxIdMissing: 'لا يوجد معرف جبائي (اختياري)',
    previewLabel: 'معاينة الملصق',
    previewCaption: 'المرسل',
    sectionContext: 'خانة «المرسل» المطبوعة على كل ملصق طرد (Mylerz، الأمانة، شركة الاختبار).',
    sectionTitle: 'الملصقات',
    title: 'المرسل',
    help: 'تظهر هذه البيانات في خانة «المرسل» في كل ملصق.',
    name: 'اسم المتجر',
    phone: 'الهاتف',
    address: 'العنوان',
    taxId: 'المعرّف الجبائي أو رقم بطاقة التعريف',
    taxIdHelp: 'اختياري.',
    fieldRequired: 'هذا الحقل إلزامي.',
    saved: 'تم حفظ المرسل',
    fill: 'إدخال بيانات المرسل',
    edit: 'تعديل',
    none: 'لا يوجد مرسل',
    noneHelp: 'أدخله لتتمكن من طباعة الملصقات.',
  },
  carriers: {
    customerFee: 'معلوم التوصيل على الحريف',
    customerFeeHelp: 'سعر ثابت لكل طرد على الحريف: يحدّد معلوم التوصيل في الطلبات التي تختار هذا الناقل.',
    customerFeeInvalid: 'أدخل مبلغًا موجبًا بثلاثة أرقام عشرية على الأكثر.',
    customerFeeShown: 'معلوم الحريف: {{fee}}',
    connectedCount: 'مرتبطة: {{count}} من {{total}}',
    secretHint: 'بيانات دخول مشفّرة، تنتهي بـ',
    changeCredentials: 'تغيير بيانات الدخول',
    connect: 'ربط',
    state_soonHelp: 'هذا الربط قيد التحضير.',
    state_soon: 'قريبًا',
    state_notConnectedHelp: 'أدخل بيانات الدخول التي منحتك إياها الشركة.',
    state_notConnected: 'غير مرتبطة',
    state_pausedHelp: 'الإرسال معلّق. بيانات الدخول محفوظة.',
    state_paused: 'متوقفة مؤقتًا',
    state_connectedHelp: 'يمكن إرسال طرودك مع هذه الشركة.',
    state_connected: 'مرتبطة',
    title: 'شركات التوصيل',
    context: 'شركات التوصيل التي تستلم طرودك. اربط الشركات التي لديك عقد معها.',
    carrier: 'شركة التوصيل',
    none: 'لا توجد شركة توصيل متاحة',
    accountTitle: 'حساب {{carrier}}',
    accountHelpNew: 'أدخل بيانات الدخول التي زوّدتك بها شركة التوصيل.',
    accountHelpReplace: 'لا تُعرض بيانات الدخول الحالية أبدًا. أدخلها من جديد لاستبدالها.',
    fieldRequired: 'هذا الحقل إلزامي.',
    enabled: 'استخدام هذا الحساب للشحن',
    enabledHelp: 'أوقفه لتعليق الإرسال دون فقدان بيانات الدخول.',
    saved: 'تم حفظ حساب {{carrier}}',
    field_apiKey: 'مفتاح API',
    field_username: 'اسم المستخدم',
    field_password: 'كلمة المرور',
    field_token: 'الرمز',
    field_userId: 'معرّف العميل',
    field_warehouseName: 'مستودع الاستلام',
    field_parcelType: 'نوع الطرد',
  },
  table: { previous: 'السابق', next: 'التالي', range: '{{from}}–{{to}} من {{total}}' },
};
